export const QUESTIONS = [
  {
    "id": 1,
    "question": "How does Amazon SageMaker Clarify help ensure fairness in machine learning models?",
    "choice_a": "By optimizing model performance metrics",
    "choice_b": "By integrating with AWS Shield for security",
    "choice_c": "By automatically generating training datasets",
    "choice_d": "By providing tools for data bias detection and model explainability",
    "correct_answer": "D",
    "explanation": "SageMaker Clarify provides capabilities for detecting bias in datasets and models, explains model behavior, and helps ensure fairness and transparency in machine learning applications.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      357,
      358,
      339,
      347,
      346
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 2,
    "question": "A data science team wants to provide multiple example questions and answers to the model in the prompt so it can better understand the desired format and content of responses. Which prompt engineering technique are they using?",
    "choice_a": "Single-shot prompting",
    "choice_b": "Few-shot prompting",
    "choice_c": "Zero-shot prompting",
    "choice_d": "Chain-of-thought prompting",
    "correct_answer": "B",
    "explanation": "Few-shot prompting involves including a few example inputs and outputs in the prompt to help guide the model’s responses based on the desired format or reasoning style.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      199,
      200,
      197,
      194,
      195
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 3,
    "question": "A retail company is evaluating multimodal models to enhance customer experience through complex data processing. What feature best describes the capability of a multimodal model suitable for analyzing both visual and textual customer data?",
    "choice_a": "A multimodal model handles multiple input types but is restricted to producing single, fixed-format outputs such as text-only.",
    "choice_b": "A multimodal model can process and analyze diverse input types like images, texts, and audio, producing outputs suited to different formats such as text or audio.",
    "choice_c": "A multimodal model exclusively processes text data to generate various output types, including text and audio.",
    "choice_d": "A multimodal model can only process a single input type at a time, such as text or images, for generating text-only outputs.",
    "correct_answer": "B",
    "explanation": "Multimodal models are capable of processing and integrating various input types (e.g., text, images, audio) and can produce flexible, format-appropriate outputs. This makes them suitable for complex data analysis tasks across diverse modalities.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      68,
      69,
      106,
      78,
      107
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 4,
    "question": "A financial services company is developing a machine learning model to predict fraudulent transactions in real time. To ensure that the predictions remain accurate over time and the model does not degrade in performance, the data science team must monitor the model and take corrective actions as needed. Which AWS services/tools can be used to monitor and maintain model performance effectively? (Choose two.)",
    "choice_a": "Amazon SageMaker Clarify",
    "choice_b": "AWS Config",
    "choice_c": "Amazon SageMaker Model Monitor",
    "choice_d": "Amazon CloudWatch",
    "choice_e": "Amazon SageMaker Debugger",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Amazon SageMaker Model Monitor helps detect data and model quality issues (e.g., data drift, prediction skew) in real time or using batch inference, making it essential for ongoing model performance maintenance. Amazon CloudWatch allows teams to collect and visualize metrics, logs, and events to monitor model behavior, triggering alerts for anomalies or operational issues.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      307,
      300,
      164,
      292,
      313
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 5,
    "question": "A company is deploying a Large Language Model (LLM) on AWS and needs to control the creativity level of the model to fit different user scenarios. Which inference parameter would be most recommended to fine-tune the variability of the model’s outputs?",
    "choice_a": "Temperature",
    "choice_b": "Top-K",
    "choice_c": "Top-P",
    "choice_d": "Stop Sequence",
    "correct_answer": "A",
    "explanation": "The temperature parameter controls the randomness or creativity of LLM outputs. Lower values (e.g., 0.2) make the model more deterministic and focused, while higher values (e.g., 0.8) increase variability and creativity. This makes it the most direct and intuitive control for adjusting output diversity.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      185,
      186,
      187
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 6,
    "question": "A financial services company is exploring Amazon Bedrock to streamline its AI development for use cases such as fraud detection, personalized customer service, and automated reporting. The company is particularly interested in understanding the key features and benefits of Amazon Bedrock, including its ability to simplify access to powerful foundation models, support customizations, and integrate with existing AWS services. To make an informed decision, the company needs to identify which of the following accurately applies to Amazon Bedrock and its capabilities?",
    "choice_a": "You can use the on-demand mode only with time-based term commitments",
    "choice_b": "You can use a customized model only in the provisioned throughput mode",
    "choice_c": "You can use a customized model in the provisioned throughput or on-demand mode",
    "choice_d": "Larger models are cheaper to use than smaller models",
    "correct_answer": "B",
    "explanation": "Amazon Bedrock allows the use of customized models only in provisioned throughput. The on-demand option is not available for models customized on Amazon Bedrock.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      133,
      132,
      130,
      131,
      129
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 7,
    "question": "In the context of a healthcare company using AWS to develop a machine learning model to predict patient outcomes, which strategy would be most effective for identifying and mitigating the risk of model overfitting?",
    "choice_a": "Using a larger dataset to train the model",
    "choice_b": "Increasing the complexity of the model to capture more subtle patterns in the data",
    "choice_c": "Reducing the number of training epochs to minimize computational costs",
    "choice_d": "Applying regularization techniques such as L1 or L2 regularization",
    "correct_answer": "D",
    "explanation": "Regularization techniques like L1 and L2 help mitigate overfitting by penalizing large weights in the model, which discourages the model from becoming overly complex and fitting to noise in the training data.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      10,
      11,
      9,
      163,
      307
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 8,
    "question": "A media company wants to automatically categorize thousands of archived videos by detecting objects, scenes, and activities in each video. They need a highly scalable solution that can process videos stored in Amazon S3 and integrate easily with other AWS services for further processing and data handling. Which Amazon service is most suitable for this requirement?",
    "choice_a": "Amazon Transcribe",
    "choice_b": "Amazon SageMaker",
    "choice_c": "Amazon Rekognition",
    "choice_d": "AWS Lambda",
    "correct_answer": "C",
    "explanation": "Amazon Rekognition Video is designed for analyzing video files to detect objects, scenes, faces, activities, and inappropriate content. It integrates natively with Amazon S3, scales automatically, and connects seamlessly with other AWS services for downstream processing.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      149,
      306,
      150,
      162,
      148
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 9,
    "question": "A company is building a financial analysis tool powered by an AI model. The model sometimes provides risky advice that doesn’t align with business guidelines. To prevent this, they want to set restrictions on the types of responses the model can give. Which prompt engineering best practice would help you establish these restrictions?",
    "choice_a": "Adding guardrails in the prompt to limit risky or non-compliant responses",
    "choice_b": "Providing longer examples to guide the model’s responses",
    "choice_c": "Using zero-shot prompts for more direct answers",
    "choice_d": "Increasing input/output length to avoid cutting off important details",
    "correct_answer": "A",
    "explanation": "Adding guardrails within the prompt helps set clear behavioral expectations for the AI model, instructing it to avoid risky, non-compliant, or prohibited responses. This is a critical prompt engineering technique for aligning model behavior with business or regulatory standards.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      225,
      195,
      204,
      197,
      194
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 10,
    "question": "A manufacturing company has developed a machine learning model for classifying various materials such as metals, plastics, and fabrics based on images from its production line. To assess this model’s ability to distinguish accurately between these materials, which evaluation metric would provide the most comprehensive insights into both the model’s accuracy and its classification errors?",
    "choice_a": "Correlation matrix",
    "choice_b": "Confusion matrix",
    "choice_c": "Mean Absolute Error (MAE)",
    "choice_d": "Root Mean Squared Error (RMSE)",
    "correct_answer": "B",
    "explanation": "A confusion matrix is the most appropriate evaluation metric for classification tasks. It provides a detailed breakdown of correct and incorrect predictions for each class, allowing teams to assess not only the overall accuracy but also which specific classes are being misclassified and why.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      262,
      293
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 250,
    "question": "An organization has a large collection of unlabeled legal documents. It wants a pretrained foundation model to acquire deeper knowledge of legal terminology and writing patterns before performing task-specific fine-tuning. Which model-customization technique should it use?",
    "choice_a": "Transfer learning",
    "choice_b": "Continuous pre-training",
    "choice_c": "Instruction tuning",
    "choice_d": "Chain-of-thought prompting",
    "correct_answer": "B",
    "explanation": "Continuous pre-training extends a foundation model's pre-training by exposing it to additional unlabeled, domain-specific data. This helps the model acquire specialized knowledge, terminology, and writing patterns. Instruction tuning can subsequently teach the model to perform specific tasks using labeled prompt-response examples.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      263,
      276,
      248,
      253,
      262
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 12,
    "question": "An insurance company is utilizing AWS and is interested in deploying Amazon Bedrock for generating product recommendations. They intend to enhance the model’s functionality by incorporating company-specific data into the foundation model. Which approach would be most effective for integrating this data?",
    "choice_a": "Directly fine-tune the base foundation model used by Amazon Bedrock using the company’s private data repositories.",
    "choice_b": "Apply Natural Language Processing (NLP) models directly without incorporating any private company data, relying solely on generic data.",
    "choice_c": "Implement Reinforcement Learning from Human Feedback (RLHF) on Amazon Bedrock using the company-specific data to teach the foundation model.",
    "choice_d": "Use knowledge bases in Amazon Bedrock to enrich the foundation model with contextual information from company-specific data using Retrieval Augmented Generation (RAG).",
    "correct_answer": "D",
    "explanation": "Knowledge bases in Amazon Bedrock, combined with Retrieval Augmented Generation (RAG), allow you to connect private, company-specific data to the foundation model without needing to fine-tune it.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      221,
      215,
      222,
      225,
      248
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 13,
    "question": "A retail company wants to utilize AWS services to create dynamic, interactive dashboards and visualizations for monitoring their sales performance in real time. Which AWS service would be the most appropriate to fulfill this requirement?",
    "choice_a": "Amazon SageMaker Data Wrangler",
    "choice_b": "Amazon QuickSight",
    "choice_c": "Amazon SageMaker Canvas",
    "choice_d": "Amazon CloudWatch Dashboards",
    "correct_answer": "B",
    "explanation": "Amazon QuickSight is AWS’s fully managed business intelligence (BI) service that allows users to create dynamic, interactive dashboards and visualizations from a variety of data sources. It is specifically designed for building real-time, business-oriented analytics views, such as sales performance monitoring.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      134,
      135,
      129,
      130,
      326
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 14,
    "question": "As a data engineer working with legal documents, you are tasked with extracting structured data from scanned documents for an automated compliance check system using AWS. Which Amazon Textract feature should you primarily use to achieve accurate extraction of data like dates, currency amounts, and table content from these documents?",
    "choice_a": "Use Amazon Textract’s Text Detection feature for extracting plain text data.",
    "choice_b": "Employ Amazon Textract’s Document Analysis feature to process complex documents and extract structured data.",
    "choice_c": "Implement Amazon Comprehend to analyze the document content for specific information.",
    "choice_d": "Utilize Amazon Textract’s Form Analysis feature to extract form-based data and relationships.",
    "correct_answer": "B",
    "explanation": "Amazon Textract’s Document Analysis feature is specifically designed for extracting structured data such as tables, forms, and key-value pairs from complex documents like legal contracts, invoices, and compliance forms.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      131,
      69,
      134,
      133,
      135
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 15,
    "question": "A development team is evaluating Amazon Q Developer for enhancing their code quality and productivity. What specific capability does Amazon Q Developer provide that would benefit this objective?",
    "choice_a": "Amazon Q Developer can create Large Language Model (LLM) chatbots, enabling the team to build and manage conversational AI models.",
    "choice_b": "Amazon Q Developer can suggest code snippets, providing developers with targeted recommendations based on the context of the code.",
    "choice_c": "Amazon Q Developer can deploy applications, automating deployment processes from development through to production.",
    "choice_d": "Amazon Q Developer can create SageMaker models, allowing developers to build, train, and deploy machine learning models.",
    "correct_answer": "B",
    "explanation": "Amazon Q Developer enhances developer productivity by providing code suggestions, explanations, and targeted recommendations based on the code’s context within IDEs like VS Code or JetBrains. This capability supports faster development, better code quality, and learning through inline assistance.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      134,
      135,
      107,
      129,
      78
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 16,
    "question": "A manufacturing company aims to utilize Amazon Bedrock for creating a generative AI application that automates the monitoring of inventory levels, sales data, and supply chain information. The application is expected to recommend optimal reorder points and quantities to enhance operational efficiency. What feature should primarily be implemented to achieve this functionality?",
    "choice_a": "Guardrails for Amazon Bedrock",
    "choice_b": "Knowledge Bases for Amazon Bedrock",
    "choice_c": "Watermark detection for Amazon Bedrock",
    "choice_d": "Agents for Amazon Bedrock",
    "correct_answer": "D",
    "explanation": "Agents for Amazon Bedrock enable the orchestration of multistep reasoning and task execution by leveraging tools, APIs, and foundation models. This makes them ideal for applications that require automation based on dynamic data—such as monitoring inventory, analyzing trends, and recommending actions like reorder points.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      131,
      130,
      107,
      129,
      133
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 17,
    "question": "An AI-focused healthcare company aims to enhance its sustainability by selecting the most energy-efficient Amazon EC2 instance type for processing extensive machine learning workloads related to analyzing patient outcomes. Which EC2 instance type should the company choose to reduce its environmental impact while maintaining top-notch performance capabilities for training complex AI models?",
    "choice_a": "Accelerated Computing G type instances",
    "choice_b": "AWS Trainium instances",
    "choice_c": "Compute Optimized C type instances",
    "choice_d": "Accelerated Computing P type instances",
    "correct_answer": "B",
    "explanation": "AWS Trainium instances are specifically designed for high-performance ML training with energy efficiency in mind. They provide excellent throughput for training deep learning models while optimizing for lower cost and smaller carbon footprint, aligning with sustainability goals.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      133,
      106,
      129,
      135,
      67
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 18,
    "question": "When implementing a search solution that involves automated redaction of personally identifiable information (PII) from support tickets, which AWS service is specifically designed to identify and redact sensitive data?",
    "choice_a": "Amazon Textract",
    "choice_b": "Amazon Kendra",
    "choice_c": "Amazon Comprehend",
    "choice_d": "Amazon Lex",
    "correct_answer": "C",
    "explanation": "Amazon Comprehend offers built-in capabilities to detect and redact PII, such as names, addresses, phone numbers, and financial information from text. It uses NLP to automatically identify sensitive data.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      403,
      413,
      410,
      381,
      401
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 19,
    "question": "When assessing the capabilities of foundation models within the AWS ecosystem for tasks such as image recognition and natural language processing, which statement best describes their functionality?",
    "choice_a": "Foundation models can only perform tasks they were initially trained for and require extensive retraining for new tasks.",
    "choice_b": "Foundation models can perform a wide range of tasks across different domains by leveraging their extensive pre-training on large datasets.",
    "choice_c": "Foundation models are limited to handling only textual data processing tasks.",
    "choice_d": "Foundation models require a structured dataset format and cannot process unstructured data such as images and free text.",
    "correct_answer": "B",
    "explanation": "Foundation models are pre-trained on massive, diverse datasets and are designed to perform a wide range of tasks across different domains—such as image recognition, text generation, translation, summarization, and more—without needing extensive retraining.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      67,
      106,
      68,
      130,
      59
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 20,
    "question": "A retail analytics team is utilizing AWS services to analyze customer purchase history, product details, and sales trends. Their main focus is computing statistical measures and employing visualizations to uncover underlying patterns for improved decision-making about customer behavior and inventory management. Which phase of the data science process are they primarily engaging in?",
    "choice_a": "Model Deployment",
    "choice_b": "Data Preparation",
    "choice_c": "Feature Engineering",
    "choice_d": "Exploratory Data Analysis (EDA)",
    "correct_answer": "D",
    "explanation": "Exploratory Data Analysis (EDA) is the phase where teams compute statistical measures, generate visualizations, and identify trends or anomalies in the data. EDA helps uncover insights that inform model development and business strategies.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      42,
      306,
      162,
      163,
      91
    ],
    "source": "328192_AssessmentTest"
  },
  {
    "id": 21,
    "question": "Which statements correctly describe the hierarchical relationship among AI, ML, and deep learning? (Choose two.)",
    "choice_a": "Machine learning is the broadest field, encompassing both AI and deep learning.",
    "choice_b": "Deep learning is a specialized subset of machine learning that uses multilayered neural networks.",
    "choice_c": "Traditional AI methods always require less computational power than deep learning.",
    "choice_d": "Artificial intelligence is the broadest field, with machine learning being a subset of AI.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "AI is the broadest field, with ML being a subset of AI, and deep learning being a further specialized subset of ML that specifically uses multilayered neural networks. The other options are incorrect because ML is not the broadest field (it’s a subset of AI), and the text states that computational requirements vary by method—traditional AI methods don’t always require less computational power than deep learning.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      36,
      37,
      9,
      5,
      1
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 22,
    "question": "Which of the following is NOT a valid, key difference between traditional AI and deep learning approaches?",
    "choice_a": "Traditional AI systems require extensive human intervention in rule design, while deep learning requires less feature engineering.",
    "choice_b": "Deep learning typically requires larger computational resources than traditional AI methods.",
    "choice_c": "Traditional AI methods excel at processing unstructured data compared to deep learning.",
    "choice_d": "Deep learning models are generally less interpretable than traditional AI systems.",
    "correct_answer": "C",
    "explanation": "C is incorrect because traditional AI methods actually struggle with unstructured data, while deep learning excels at processing unstructured data like images, text, and speech. This is, in fact, one of deep learning’s key advantages over traditional AI approaches.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      103,
      37,
      36,
      44,
      43
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 23,
    "question": "What is a key difference between labeled and unlabeled data in AI models? (Choose two.)",
    "choice_a": "Labeled data is used in unsupervised learning.",
    "choice_b": "Unlabeled data is suitable for unsupervised learning.",
    "choice_c": "Labeled data includes input-output pairs.",
    "choice_d": "Unlabeled data includes annotated labels.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Labeled data includes input-output pairs and is essential for supervised learning, whereas unlabeled data lacks such annotations and is suitable for unsupervised learning.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      41,
      8,
      5,
      6,
      101
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 24,
    "question": "Which of the following statements about inference types is true? (Choose two.)",
    "choice_a": "Batch inference is ideal for applications needing immediate response times.",
    "choice_b": "Real-time inference generates predictions in response to user requests instantly.",
    "choice_c": "Asynchronous inference is suitable for processing large datasets all at once.",
    "choice_d": "Batch inference processes data periodically, rather than in real-time.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Batch inference processes data in bulk at scheduled intervals, making it efficient for large datasets but not suitable for real-time needs. Real-time inference, on the other hand, provides immediate predictions in response to user requests.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      55,
      300,
      162
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 25,
    "question": "What are characteristics of time-series data? (Choose two.)",
    "choice_a": "Time-series data captures sequential observations over time intervals.",
    "choice_b": "Time-series data typically does not exhibit autocorrelation.",
    "choice_c": "Time-series models are often deployed using synchronous inference.",
    "choice_d": "Time-series data is commonly used in predictive maintenance applications.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Time-series data captures observations collected at sequential time intervals and is commonly used in applications like predictive maintenance. It often exhibits autocorrelation, affecting the choice of algorithms and model architecture.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      42,
      90,
      12,
      306,
      307
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 26,
    "question": "Which of the following statements are correct about time-series and image data? (Choose two)",
    "choice_a": "Time-series data is often used for tasks like anomaly detection and predictive maintenance.",
    "choice_b": "Image data models typically rely on autocorrelation to influence future predictions.",
    "choice_c": "Convolutional neural networks (CNNs) are well-suited for analyzing time-series data.",
    "choice_d": "CNNs are commonly used for tasks like defect detection in manufacturing pipelines.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Time-series data is frequently used for tasks such as anomaly detection and predictive maintenance, while CNNs are designed for processing complex image data like defects in manufacturing.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      42,
      44,
      12,
      6,
      90
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 27,
    "question": "What is a key distinction between word embeddings and transformer models in natural language processing? (Choose two.)",
    "choice_a": "Word embeddings capture semantic relationships between words, while transformers handle context within sentences.",
    "choice_b": "Transformers primarily utilize statistical methods to represent text data.",
    "choice_c": "Word embeddings use self-attention to weigh the importance of words in a sentence.",
    "choice_d": "Transformers can capture long-range dependencies, unlike traditional word embeddings.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Word embeddings capture semantic relationships between words, but they struggle with long-range dependencies, which transformers handle effectively using self-attention mechanisms.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      13,
      43,
      12,
      103,
      9
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 28,
    "question": "Which of the following techniques allows a model to weigh the importance of each word in a sentence relative to all others?",
    "choice_a": "Term frequency-inverse document frequency (TF-IDF)",
    "choice_b": "Bag-of-words (BoW)",
    "choice_c": "Self-attention",
    "choice_d": "Word2Vec",
    "correct_answer": "C",
    "explanation": "Self-attention enables models to determine the relevance of each word to others within a sentence, which is essential for capturing context in transformer models.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      13,
      43,
      105,
      103,
      9
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 29,
    "question": "What are two key differences between neural networks and traditional algorithms in AI? (Choose two.)",
    "choice_a": "Neural networks have fixed weights that do not change during training.",
    "choice_b": "Traditional algorithms rely on explicit programming rather than data-driven learning.",
    "choice_c": "Neural networks use layers of interconnected nodes, resembling the human brain.",
    "choice_d": "Traditional algorithms always require large datasets to function effectively.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Neural networks utilize layers of interconnected nodes and adapt their weights through training, unlike traditional algorithms, which are explicitly programmed and don’t adapt based on data.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      9,
      37,
      5,
      36,
      95
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 30,
    "question": "Which of the following statements accurately describe the function of deep learning and neural networks? (Choose two.)",
    "choice_a": "Deep learning involves training models that are based on single-layer neural networks.",
    "choice_b": "Neural networks are organized into multiple layers and can handle complex tasks.",
    "choice_c": "Deep learning is solely focused on supervised learning tasks.",
    "choice_d": "Neural networks can form the foundation for many modern AI systems.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Deep learning uses neural networks with multiple layers to automatically learn complex data representations. Neural networks serve as the backbone for many AI systems by adjusting the strengths of connections between neurons based on training data.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      9,
      36,
      37,
      103,
      14
    ],
    "source": "328192_Ch01"
  },
  {
    "id": 31,
    "question": "What is the primary purpose of tokenization in Natural Language Processing (NLP) and Gen AI?",
    "choice_a": "To map words to high-dimensional vectors capturing semantic relationships.",
    "choice_b": "To convert raw text into basic units called tokens for easier processing.",
    "choice_c": "To group tokens into meaningful phrases for structural understanding.",
    "choice_d": "To reduce the size of the dataset by eliminating redundant words.",
    "correct_answer": "B",
    "explanation": "Tokenization breaks down text into tokens, making it manageable for AI models to process.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      62,
      67,
      66,
      59,
      78
    ],
    "source": "328192_Ch02"
  },
  {
    "id": 32,
    "question": "Which concept involves grouping tokens into meaningful phrases to help models understand structural relationships within language?",
    "choice_a": "Embedding",
    "choice_b": "Chunking",
    "choice_c": "Tokenization",
    "choice_d": "Diffusion",
    "correct_answer": "B",
    "explanation": "Chunking groups tokens into phrases, aiding models in grasping language structure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      67,
      66
    ],
    "source": "328192_Ch02"
  },
  {
    "id": 33,
    "question": "What is the main advantage of transformer-based models over traditional Recurrent Neural Networks (RNNs)?",
    "choice_a": "They use convolutional layers to process images.",
    "choice_b": "They require less data for training.",
    "choice_c": "They capture long-range dependencies using self-attention mechanisms.",
    "choice_d": "They are specifically designed for processing audio data.",
    "correct_answer": "C",
    "explanation": "Transformers use self-attention to consider relationships between all words in a sequence.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      66,
      67,
      333
    ],
    "source": "328192_Ch02"
  },
  {
    "id": 34,
    "question": "What is prompt engineering in the context of Gen AI?",
    "choice_a": "Designing hardware for AI models",
    "choice_b": "Crafting input prompts to guide model outputs",
    "choice_c": "Optimizing model architecture",
    "choice_d": "Creating new programming languages for AI",
    "correct_answer": "B",
    "explanation": "Prompt engineering is careful crafting of prompts to optimize model responses.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      78,
      59,
      130,
      131,
      106
    ],
    "source": "328192_Ch02"
  },
  {
    "id": 35,
    "question": "What role do embeddings play in Gen AI models?",
    "choice_a": "They generate new data by reversing a diffusion process.",
    "choice_b": "They map tokens to vectors to capture semantic relationships between data.",
    "choice_c": "They group tokens into phrases for better syntactic analysis.",
    "choice_d": "They provide examples in prompts to guide model outputs.",
    "correct_answer": "B",
    "explanation": "Embeddings represent tokens as vectors, reflecting their meanings and relationships.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      62,
      67,
      68,
      66,
      59
    ],
    "source": "328192_Ch02"
  },
  {
    "id": 36,
    "question": "Which of the following use cases is best suited for machine learning?",
    "choice_a": "Predicting stock market prices using historical data",
    "choice_b": "Manually parsing documents for information extraction",
    "choice_c": "Managing employee attendance using a traditional system",
    "choice_d": "Tracking company expenses using spreadsheet software",
    "correct_answer": "A",
    "explanation": "ML is well-suited for analyzing large sets of historical data, recognizing trends, and making predictions, whereas the other options involve repeatable and time-consuming business processes that do not leverage automation.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      90,
      42,
      8,
      100,
      95
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 37,
    "question": "A company wants to improve its customer support by automating responses to common customer queries. Which of the following technologies would be the most suitable for this purpose?",
    "choice_a": "Robotic Process Automation (RPA)",
    "choice_b": "Artificial intelligence (AI)",
    "choice_c": "Blockchain",
    "choice_d": "Manual data entry",
    "correct_answer": "B",
    "explanation": "Artificial intelligence, including natural language processing (NLP) and machine learning, can be used to train chatbots and virtual assistants to effectively understand and respond to common customer queries.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      36,
      90,
      105,
      13,
      37
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 38,
    "question": "A company wants to implement a system that can detect fraudulent activities in financial transactions. However, they have a very limited amount of labeled transaction data, and the system must be 100 percent accurate due to regulatory constraints. Which of the following approaches would be the most suitable?",
    "choice_a": "Train an ML model on the limited transaction data available.",
    "choice_b": "Use a rule-based system with explicit if-then logic to flag suspicious transactions.",
    "choice_c": "Use a deep learning neural network with minimal data.",
    "choice_d": "Apply a clustering algorithm to group transactions without labels.",
    "correct_answer": "B",
    "explanation": "Given the limited amount of labeled data and the requirement for 100 percent accuracy, a rule-based system is more suitable than an ML model. ML models require large amounts of clean, labeled data and always involve some level of uncertainty, which may not be acceptable in high-stakes financial scenarios with strict regulatory requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      5,
      41,
      8,
      37
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 39,
    "question": "An agriculture company wants to predict crop yield based on historical data, including weather conditions, soil type, and crop type. They have labeled data showing past crop yields for different conditions. Which type of machine learning algorithm should be used in this scenario?",
    "choice_a": "Unsupervised learning",
    "choice_b": "Reinforcement learning",
    "choice_c": "Clustering algorithm",
    "choice_d": "Supervised learning",
    "correct_answer": "D",
    "explanation": "Supervised learning is the best choice here because the farmer has labeled data showing past crop yields, which can be used to train a model to predict future yields based on similar conditions.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      5,
      8,
      41,
      100,
      42
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 40,
    "question": "A financial institution wants to detect potentially fraudulent transactions but does not have any labeled data indicating which transactions are fraudulent and which are legitimate. Which type of machine learning algorithm should be used in this scenario?",
    "choice_a": "Supervised learning",
    "choice_b": "Reinforcement learning",
    "choice_c": "Unsupervised learning",
    "choice_d": "Classification algorithm",
    "correct_answer": "C",
    "explanation": "The institution does not have labeled data indicating whether transactions are fraudulent, so unsupervised learning is the best choice.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      8,
      6,
      41,
      102,
      5
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 41,
    "question": "A company wants to develop a chatbot that learns the best responses to customer queries through continuous interaction and feedback, aiming to improve customer satisfaction over time. Which type of machine learning approach is most suitable for this use case?",
    "choice_a": "Reinforcement learning",
    "choice_b": "Supervised learning",
    "choice_c": "Unsupervised learning",
    "choice_d": "Clustering algorithm",
    "correct_answer": "A",
    "explanation": "Reinforcement learning is suitable for this scenario because the chatbot can learn optimal responses by receiving feedback from each interaction (rewards or penalties).",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      7,
      8,
      90
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 42,
    "question": "An e-commerce platform wants to recommend products to users based on their geographic location and past purchase behavior. They want to predict the spending amount for each user to offer personalized promotions. Which type of machine learning algorithm is best suited for this task?",
    "choice_a": "Classification",
    "choice_b": "Clustering",
    "choice_c": "Regression",
    "choice_d": "Reinforcement learning",
    "correct_answer": "C",
    "explanation": "Regression is used to predict continuous values, such as a user’s spending amount.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      100,
      8,
      5,
      91,
      41
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 43,
    "question": "An online retailer wants to group customers based on their geographic location and past purchase behavior to create personalized marketing campaigns. They do not have any predefined labels for customer groups. Which algorithm would be the most suitable for this task?",
    "choice_a": "k-nearest neighbors (KNN)",
    "choice_b": "k-means clustering",
    "choice_c": "Support vector machine (SVM)",
    "choice_d": "Linear regression",
    "correct_answer": "B",
    "explanation": "k-means clustering is an unsupervised learning algorithm that is well-suited for grouping customers without predefined labels.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      102,
      6,
      8,
      41
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 44,
    "question": "A healthcare organization needs to classify X-ray images into categories such as “Normal” or “Pneumonia.” Which deep learning model would be the most suitable for this task?",
    "choice_a": "Decision trees",
    "choice_b": "Convolutional neural networks (CNNs)",
    "choice_c": "Random forest",
    "choice_d": "k-means clustering",
    "correct_answer": "B",
    "explanation": "Convolutional neural networks (CNNs) are specifically designed to process and classify visual data, making them the best choice for tasks like medical image classification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      44,
      12,
      103,
      9
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 45,
    "question": "A content creation platform wants to allow users to generate personalized images based on textual descriptions, such as “a sunset over the mountains.” Which type of generative AI model is most suitable for this use case?",
    "choice_a": "Recurrent neural networks (RNNs)",
    "choice_b": "Generative adversarial networks (GANs)",
    "choice_c": "Random forest",
    "choice_d": "Linear regression",
    "correct_answer": "B",
    "explanation": "Generative adversarial networks (GANs) are highly effective in generating high-quality images from textual prompts or other inputs, making them ideal for tasks involving personalized image generation.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      69,
      68,
      106,
      59,
      130
    ],
    "source": "328192_Ch03"
  },
  {
    "id": 46,
    "question": "A company wants to build a generative AI application for document processing. Which of the following AWS services can be used to build this application? (Choose two.)",
    "choice_a": "Amazon Bedrock",
    "choice_b": "Amazon SageMaker JumpStart",
    "choice_c": "Amazon DynamoDB",
    "choice_d": "AWS Lambda",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Amazon Bedrock and Amazon SageMaker JumpStart are two major AWS services that can be leveraged for building Generative AI applications.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      130,
      129,
      131,
      135,
      132
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 47,
    "question": "Which AWS service provides serverless inference for generative AI with a variety of model choices behind a single API?",
    "choice_a": "Amazon SageMaker",
    "choice_b": "Amazon Bedrock",
    "choice_c": "AWS Lambda",
    "choice_d": "Amazon Comprehend",
    "correct_answer": "B",
    "explanation": "Amazon Bedrock is a managed service that provides serverless access to foundational models (FMs) for generative AI applications. It supports a variety of pre-trained models from leading AI providers like Amazon Titan, Anthropic, AI21 Labs, and Stability AI. With Bedrock, developers can build and deploy generative AI applications without managing the underlying infrastructure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      129,
      132,
      133,
      131
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 48,
    "question": "A company wants to build a generative AI application that can provide answers based on its private knowledge repository. Which Amazon Bedrock feature would help achieve this by integrating the knowledge repository with foundation models?",
    "choice_a": "Amazon Bedrock Guardrails",
    "choice_b": "Knowledge Bases for Retrieval-Augmented Generation (RAG)",
    "choice_c": "Amazon SageMaker JumpStart",
    "choice_d": "Amazon Bedrock Agents",
    "correct_answer": "B",
    "explanation": "Knowledge Bases for RAG in Amazon Bedrock enables the integration of private knowledge repositories with foundation models. This feature allows companies to retrieve and use proprietary data to enrich the generative AI model’s responses, ensuring relevant and accurate outputs specific to the organization.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      131,
      130,
      78,
      62,
      82
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 49,
    "question": "A financial services company is building a generative AI assistant to handle customer queries. The company wants to ensure that the assistant avoids generating responses related to investment advice, filters out harmful content, and protects customer privacy by redacting sensitive information like account numbers. Which Amazon Bedrock feature should the company use to enforce these requirements?",
    "choice_a": "Amazon Bedrock Agents",
    "choice_b": "Knowledge Bases for RAG",
    "choice_c": "Amazon Bedrock Guardrails",
    "choice_d": "Amazon SageMaker JumpStart",
    "correct_answer": "C",
    "explanation": "Amazon Bedrock Guardrails help organizations enforce responsible AI practices by defining restricted topics, filtering harmful content, and redacting sensitive information such as personally identifiable information (PII).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      133,
      134,
      135,
      132
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 50,
    "question": "A retail company wants to build a generative AI assistant to handle customer queries about product availability and automate tasks such as placing orders. The assistant must interact with enterprise systems, access inventory databases, and execute API calls to fulfill customer requests. Which Amazon Bedrock feature should the company use to enable these capabilities?",
    "choice_a": "Amazon Bedrock Agents",
    "choice_b": "Knowledge Bases for RAG",
    "choice_c": "Amazon Bedrock Guardrails",
    "choice_d": "AWS Lambda",
    "correct_answer": "A",
    "explanation": "Amazon Bedrock Agents are designed to plan and execute multistep tasks by interacting with enterprise systems, APIs, and knowledge bases. In this scenario, the assistant can use Agents to retrieve data from inventory systems, process customer orders, and automate workflows, ensuring seamless task execution and enhanced customer experience.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      131,
      133,
      130,
      129,
      107
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 51,
    "question": "A company wants to customize and deploy foundation models for its generative AI application. Which AWS service provides an easy and comprehensive way to fine-tune and deploy these models? (Choose two.)",
    "choice_a": "Amazon Bedrock",
    "choice_b": "Amazon SageMaker",
    "choice_c": "AWS Lambda",
    "choice_d": "Amazon Comprehend",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Amazon SageMaker and Amazon Bedrock provide a comprehensive suite of tools for fine-tuning, training, and deploying foundation models. Features like SageMaker JumpStart simplify the process by offering pre-built solutions, allowing businesses to quickly customize models for their specific use cases and deploy them at scale, making it an ideal choice for this requirement.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      132,
      129,
      326,
      130,
      131
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 52,
    "question": "Why is model customization important when deploying foundation models (FMs) for generative AI applications?",
    "choice_a": "To improve the scalability of the foundational model across different cloud providers.",
    "choice_b": "To tailor the foundational model’s behavior to specific tasks or domain-specific requirements.",
    "choice_c": "To reduce the size of the foundational model for faster inference.",
    "choice_d": "To ensure the foundational model operates independently of external data sources.",
    "correct_answer": "B",
    "explanation": "Model customization is essential to adapt foundational models to specific use cases, tasks, or industries. By fine-tuning the model using proprietary data or performing continued pre-training, businesses can enhance the model’s relevance and accuracy for domain-specific applications.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      132,
      131,
      78,
      107,
      129
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 53,
    "question": "A technology company wants to improve employee productivity by providing an AI assistant that can help developers troubleshoot code, perform security scans, and generate new features. The assistant should also help business users by summarizing reports, automating emails, and answering questions based on internal company policies and data. Which AWS service would best meet these requirements?",
    "choice_a": "Amazon Redshift",
    "choice_b": "Amazon S3",
    "choice_c": "Amazon Q",
    "choice_d": "Amazon Comprehend",
    "correct_answer": "C",
    "explanation": "Amazon Q is a generative AI assistant designed to enhance productivity for both developers and business users.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      134,
      135,
      107,
      129,
      131
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 54,
    "question": "A company wants to extract key entities such as names, dates, and locations from a large set of unstructured text documents. Which of the following AWS AI services would be the most suitable for this task? (Choose two.)",
    "choice_a": "Amazon Rekognition",
    "choice_b": "Amazon Comprehend",
    "choice_c": "Amazon Bedrock",
    "choice_d": "AWS Glue",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Amazon Comprehend is an AWS AI service specifically designed to extract entities such as names, dates, and locations from unstructured text. Amazon Bedrock provides foundational models and services that can be leveraged for this entity extraction task.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      129,
      130,
      131
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 55,
    "question": "A global e-commerce company wants to provide customer support in multiple languages by translating customer queries into English for their support agents, and translating responses back into the customer’s preferred language. Which AWS AI service would be the most suitable for this use case?",
    "choice_a": "Amazon Translate",
    "choice_b": "Amazon Polly",
    "choice_c": "Amazon Lex",
    "choice_d": "Amazon SageMaker",
    "correct_answer": "A",
    "explanation": "Amazon Translate is the most suitable service for translating text between different languages, enabling the customer support team to communicate with customers in their preferred language.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      134,
      130,
      62,
      135
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 56,
    "question": "A business analyst wants to create machine learning models to forecast sales without writing any code. Which AWS service should they use to easily create, train, and explore ML models without requiring programming experience?",
    "choice_a": "Amazon Comprehend",
    "choice_b": "Amazon Forecast",
    "choice_c": "Amazon SageMaker Feature Store",
    "choice_d": "Amazon SageMaker Canvas",
    "correct_answer": "D",
    "explanation": "Amazon SageMaker Canvas is a no-code tool that allows users to create, train, and explore machine learning models without needing any programming experience.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      165,
      162,
      163,
      299,
      164
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 57,
    "question": "Which AWS service allows you to store, update, and retrieve machine learning features for both training and inference, ensuring consistency between the two stages?",
    "choice_a": "Amazon Redshift",
    "choice_b": "Amazon RDS",
    "choice_c": "Amazon SageMaker Feature Store",
    "choice_d": "AWS Lambda",
    "correct_answer": "C",
    "explanation": "Amazon SageMaker Feature Store is a fully managed repository that allows users to store, update, and retrieve features for machine learning, ensuring consistency between training and inference stages.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      163,
      162,
      307,
      164,
      300
    ],
    "source": "328192_Ch04"
  },
  {
    "id": 58,
    "question": "What is the primary consideration when evaluating costs for pre-trained models?",
    "choice_a": "Only the direct API call pricing",
    "choice_b": "Only the computational resources required",
    "choice_c": "Both direct pricing and indirect costs, including computational resources and engineering time",
    "choice_d": "Only the storage costs for model weights",
    "correct_answer": "C",
    "explanation": "When evaluating costs, organizations must consider both direct pricing (like inference costs) and indirect costs such as computational resources and engineering time.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      332,
      326,
      82,
      333
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 59,
    "question": "Multiple Option Difficulty: Hard Chapter: 5 H1 Section: Domain: Application of Foundation models Subdomain: Describe design considerations for applications that use foundation models 2.\tWhich of the following statements are true regarding model selection criteria? (Choose three.)",
    "choice_a": "Larger models always provide the most cost-effective solution for all applications.",
    "choice_b": "Models can excel at specific modalities while having limited capabilities in others.",
    "choice_c": "Sub-second response times are crucial for interactive applications.",
    "choice_d": "Model size impacts deployment options, resource requirements, and operational costs.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Larger models aren’t always cost-effective (invalidating A), while B is supported by the modality section, C is confirmed in the latency requirements section, and D is explicitly stated in the model size and complexity section.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      175,
      177,
      174,
      176,
      248
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 60,
    "question": "Which setting would be most appropriate when using an LLM for extracting specific data points from a text document?",
    "choice_a": "Temperature = 0.9",
    "choice_b": "Temperature = 0.1",
    "choice_c": "Temperature = 2.0",
    "choice_d": "Temperature = 1.5",
    "correct_answer": "B",
    "explanation": "Temperature settings close to 0.0 make the model more deterministic and focused, which is ideal for data extraction tasks.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      185,
      186,
      187,
      197,
      195
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 61,
    "question": "Which statements about temperature settings in LLMs are correct?",
    "choice_a": "Higher temperature settings guarantee more accurate and factual responses.",
    "choice_b": "Temperature is a physical unit to measure heat; it has nothing to do with LLMs.",
    "choice_c": "A temperature setting of 2.0 produces the most deterministic outputs.",
    "choice_d": "Temperature affects the probability distribution of token selection during generation.",
    "correct_answer": "D",
    "explanation": "Higher temperature settings make the probability distribution more uniform across tokens, while lower settings make it more concentrated on the most likely tokens. This results in the model generating more “creative” looking output for higher temperature values.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      185,
      187,
      186
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 62,
    "question": "What is the recommended range of top-p sampling values for achieving a good balance between creativity and coherence?",
    "choice_a": "0.1–0.3",
    "choice_b": "0.3–0.7",
    "choice_c": "0.7–0.9",
    "choice_d": ">0.9",
    "correct_answer": "B",
    "explanation": "The balanced range of 0.3–0.7 for top-p sampling provides a good mix of creativity and coherence.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      186,
      185,
      187
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 251,
    "question": "Which statements correctly describe foundation model inference parameters? (Choose two.)",
    "choice_a": "A higher temperature increases the likelihood of selecting lower-probability tokens.",
    "choice_b": "A lower top-p value expands the pool of tokens considered by the model.",
    "choice_c": "The maximum-token parameter limits the length of the generated response.",
    "choice_d": "Inference-parameter defaults and valid ranges are identical across foundation models.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A higher temperature makes generation less deterministic by increasing the likelihood of lower-probability tokens. The maximum-token parameter limits how many tokens the model can generate. A lower top-p value narrows (not expands) the candidate pool, and parameter defaults and valid ranges can vary by model.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      185,
      186,
      196
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 64,
    "question": "What is the primary purpose of providing clear instructions to an AI model?",
    "choice_a": "To make the conversation more casual",
    "choice_b": "To reduce the model’s processing speed",
    "choice_c": "To obtain more accurate and relevant responses",
    "choice_d": "To test the model’s creative abilities",
    "correct_answer": "C",
    "explanation": "The main purpose of providing clear instructions to an AI model is to obtain accurate and relevant responses.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      195,
      194,
      199,
      197,
      198
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 65,
    "question": "Which of the following are essential elements of providing effective instructions to an AI model? (Choose three.)",
    "choice_a": "Including specific parameters and constraints",
    "choice_b": "Using ambiguous or vague language",
    "choice_c": "Clearly stating the desired output format",
    "choice_d": "Breaking down complex requests into specific steps",
    "choice_e": "Using casual conversational tone",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The correct answers include specifying parameters, stating the desired output format, and breaking down complex requests, as these elements help ensure clear communication and precise outputs from the AI model.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      195,
      197,
      202,
      199,
      194
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 66,
    "question": "Which of the following best describes the primary benefit of using “chain-of-thought” prompting in generative AI?",
    "choice_a": "It reduces token usage in the model.",
    "choice_b": "It helps the model break down complex problems into logical steps.",
    "choice_c": "It eliminates the need for human verification.",
    "choice_d": "It increases processing speed.",
    "correct_answer": "B",
    "explanation": "Chain-of-thought prompting helps models break down complex problems into smaller, logical steps, improving reasoning and accuracy in responses.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      202,
      196,
      195,
      194,
      199
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 67,
    "question": "A developer needs to constrain an LLM’s output to ensure it generates responses that are exactly 50 words long while maintaining semantic coherence. Which of the following approaches would be most effective?",
    "choice_a": "Using simple word count parameters in the prompt",
    "choice_b": "Implementing a token-based truncation system",
    "choice_c": "Combining word count constraints with semantic preservation rules in the system prompt",
    "choice_d": "Manually editing the output after generation",
    "correct_answer": "C",
    "explanation": "The most effective approach combines word count constraints with semantic preservation rules in the system prompt, as this ensures both the exact length requirement and maintains meaningful content throughout the response.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      196,
      197,
      195,
      199,
      187
    ],
    "source": "328192_Ch05"
  },
  {
    "id": 68,
    "question": "What is the primary function of Amazon Bedrock Knowledge Bases?",
    "choice_a": "To store and manage large datasets for training machine learning models",
    "choice_b": "To securely connect foundation models (FMs) to your data sources for retrieval augmentation, enhancing the model’s responses with relevant, context-specific information",
    "choice_c": "To provide a marketplace for various AI models from different providers",
    "choice_d": "To offer a development environment for building and testing machine learning algorithms",
    "correct_answer": "B",
    "explanation": "Amazon Bedrock Knowledge Bases enable you to securely connect foundation models (FMs) to your data sources for retrieval augmentation, enhancing the model’s responses with relevant, context-specific information.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      221,
      222,
      225,
      215,
      224
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 69,
    "question": "Which of the following data sources can be connected to Amazon Bedrock Knowledge Bases?",
    "choice_a": "Amazon S3, Confluence, Salesforce, and SharePoint",
    "choice_b": "Amazon RDS, Google Drive, Dropbox, and OneDrive",
    "choice_c": "Amazon DynamoDB, GitHub, Bitbucket, and Slack",
    "choice_d": "Amazon Redshift, Trello, Asana, and Jira",
    "correct_answer": "A",
    "explanation": "Amazon Bedrock Knowledge Bases supports integration with data sources, including Amazon S3, Confluence, Salesforce, and SharePoint.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      222,
      221,
      215,
      225,
      223
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 70,
    "question": "A financial analyst wants to use an AI-powered assistant to retrieve and analyze multifaceted financial data, including text documents and audio files. Which combination of Amazon Bedrock services would best facilitate this requirement?",
    "choice_a": "Amazon Bedrock Knowledge Bases and Amazon Bedrock Data Automation",
    "choice_b": "Amazon Bedrock Knowledge Bases and Amazon Bedrock Agents",
    "choice_c": "Amazon Bedrock Agents and Amazon DynamoDB",
    "choice_d": "Amazon Bedrock Agents and Amazon Kendra",
    "correct_answer": "A",
    "explanation": "Amazon Bedrock Knowledge Bases and Data Automation can ingest and process unstructured data, such as text and audio files, converting them into embeddings stored in a vector database.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      221,
      224,
      215,
      223,
      225
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 71,
    "question": "Which feature of Amazon Bedrock Agents allows for dynamic adjustment of an agent’s behavior at runtime?",
    "choice_a": "Inline agents",
    "choice_b": "Static configuration files",
    "choice_c": "Predefined templates",
    "choice_d": "Manual code deployment",
    "correct_answer": "A",
    "explanation": "Inline agents are serverless agents that allow you to build AI applications that can take actions and retrieve information based on user requests. They enable foundation models to interact with internal tools and data sources through natural language conversations without requiring complex infrastructure setup.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      237,
      238,
      200,
      187,
      276
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 72,
    "question": "What is a common use case for Amazon Bedrock Agents in a business environment?",
    "choice_a": "Developing mobile applications for e-commerce platforms",
    "choice_b": "Automating complex business tasks such as processing insurance claims or managing inventory by dynamically calling company systems and APIs",
    "choice_c": "Designing graphics and multimedia content for marketing campaigns",
    "choice_d": "Managing network infrastructure and security protocols",
    "correct_answer": "B",
    "explanation": "A common use case for Amazon Bedrock Agents is for automating complex business tasks such as processing insurance claims or managing inventory by dynamically calling company systems and APIs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      237,
      238,
      239
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 73,
    "question": "An automotive parts retailer aims to enhance its customer support by providing real-time, context-aware responses about product availability and compatibility. How can Amazon Bedrock Agents and Knowledge Bases be utilized to achieve this goal?",
    "choice_a": "By using Amazon Bedrock Knowledge Bases to generate responses and Amazon S3 to store customer interaction logs",
    "choice_b": "By implementing Amazon Bedrock Agents to manage inventory data and Knowledge Bases to process payment transactions",
    "choice_c": "By using Amazon Bedrock Knowledge Bases to handle customer queries and Amazon Bedrock Agents to store product information",
    "choice_d": "By deploying Amazon Bedrock Agents to handle customer queries and using Knowledge Bases to store and retrieve up-to-date inventory and product information",
    "correct_answer": "D",
    "explanation": "Amazon Bedrock Agents can interpret and respond to customer inquiries by accessing relevant data stored in Amazon Bedrock Knowledge Bases. These knowledge bases connect to data sources like inventory management systems and product catalogs, enabling the agent to provide accurate, real-time information on product availability and compatibility.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      237,
      221,
      222,
      238,
      215
    ],
    "source": "328192_Ch06"
  },
  {
    "id": 74,
    "question": "Which of the following best describes a key objective of data preparation before fine-tuning a foundation model?",
    "choice_a": "Reducing training time by ignoring incomplete data",
    "choice_b": "Transforming raw data into a representative, high-quality dataset",
    "choice_c": "Eliminating all data points that don’t fit the model’s output criteria",
    "choice_d": "Limiting the dataset to reduce operational costs",
    "correct_answer": "B",
    "explanation": "Data preparation involves cleaning, labeling, and ensuring representativeness to create a robust dataset that accurately reflects the target domain.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      262,
      286,
      274,
      253,
      254
    ],
    "source": "328192_Ch07"
  },
  {
    "id": 75,
    "question": "What distinguishes fine-tuning from pre-training in the context of foundation models?",
    "choice_a": "Fine-tuning always requires more data than pre-training.",
    "choice_b": "Pre-training is supervised, while fine-tuning is unsupervised.",
    "choice_c": "Fine-tuning adapts a pre-trained model to a specific task or domain.",
    "choice_d": "Pre-training uses labeled data, whereas fine-tuning uses unlabeled data.",
    "correct_answer": "C",
    "explanation": "Pre-training exposes the model to large, diverse datasets to learn general patterns. Fine-tuning then refines these learned capabilities for a specialized application.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      248,
      262,
      276,
      253,
      263
    ],
    "source": "328192_Ch07"
  },
  {
    "id": 76,
    "question": "Which metric is most appropriate for evaluating the performance of a classification model when class distribution is imbalanced?",
    "choice_a": "Accuracy",
    "choice_b": "F1 Score",
    "choice_c": "BLEU",
    "choice_d": "ROUGE",
    "correct_answer": "B",
    "explanation": "F1 Score balances precision and recall, making it better suited than simple accuracy for handling imbalanced classification tasks.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      292,
      101,
      307
    ],
    "source": "328192_Ch07"
  },
  {
    "id": 77,
    "question": "What is the primary advantage of using Parameter Efficient Fine-Tuning (PEFT) methods like LoRA compared to traditional fine-tuning?",
    "choice_a": "They always produce better results than full fine-tuning.",
    "choice_b": "They only update a subset of parameters, reducing computational costs.",
    "choice_c": "They require larger datasets to be effective.",
    "choice_d": "They completely replace the original model weights.",
    "correct_answer": "B",
    "explanation": "PEFT methods adjust only a small subset of parameters, which leads to faster training and lower computational costs while still effectively adapting the model to specific tasks.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      264,
      248,
      176,
      262,
      276
    ],
    "source": "328192_Ch07"
  },
  {
    "id": 78,
    "question": "What is a key challenge in continuous pre-training that must be managed to maintain model performance?",
    "choice_a": "Overfitting to domain-specific data",
    "choice_b": "Catastrophic forgetting of general knowledge",
    "choice_c": "Increased computational costs",
    "choice_d": "Inability to handle specialized vocabulary",
    "correct_answer": "B",
    "explanation": "A key technical challenge in continuous pre-training is managing catastrophic forgetting, where the model risks losing the general-purpose knowledge gained during the initial large-scale pre-training.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      263,
      276,
      253,
      248
    ],
    "source": "328192_Ch07"
  },
  {
    "id": 79,
    "question": "Which of the following is the primary goal of MLOps in an organization?",
    "choice_a": "Reducing data collection costs by limiting sources",
    "choice_b": "Streamlining the ML lifecycle from experimentation to production",
    "choice_c": "Ensuring all models are open source",
    "choice_d": "Limiting the model’s complexity to reduce memory usage",
    "correct_answer": "B",
    "explanation": "MLOps focuses on unifying people, processes, and tools so that machine learning models can be developed, deployed, and maintained efficiently and at scale.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      299,
      313,
      307,
      164,
      163
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 80,
    "question": "In an MLOps pipeline, which stage typically involves transforming raw data into meaningful input features for a model?",
    "choice_a": "Monitoring",
    "choice_b": "Model deployment",
    "choice_c": "Feature engineering",
    "choice_d": "Hyperparameter tuning",
    "correct_answer": "C",
    "explanation": "Feature engineering converts raw data into more useful representations, improving the model’s ability to learn and perform accurately.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      12,
      306,
      163,
      299,
      42
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 81,
    "question": "What is the main difference between MLOps and LLMOps?",
    "choice_a": "LLMOps is only for on-premises deployments.",
    "choice_b": "MLOps is purely for deep learning, while LLMOps is for traditional ML.",
    "choice_c": "LLMOps deals with the unique challenges of large language and foundation models.",
    "choice_d": "MLOps requires specialized GPUs, while LLMOps does not.",
    "correct_answer": "C",
    "explanation": "While MLOps covers operationalizing various ML models, LLMOps focuses on the complexities of adapting, deploying, and monitoring large language or foundation models that often require specialized approaches for fine-tuning and evaluation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      332,
      333,
      131,
      326
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 82,
    "question": "Which AWS service would you use to automate the end-to-end workflow of data preprocessing, model training, and deployment?",
    "choice_a": "Amazon S3",
    "choice_b": "AWS Glue",
    "choice_c": "Amazon SageMaker Pipelines",
    "choice_d": "Amazon Athena",
    "correct_answer": "C",
    "explanation": "SageMaker Pipelines orchestrates the entire ML workflow, from data preparation to training and deployment, providing a repeatable, automated framework.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      313,
      299,
      163,
      164,
      314
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 83,
    "question": "In the context of inference types, when would you prefer a real-time endpoint over batch processing?",
    "choice_a": "When processing large datasets offline on a nightly schedule",
    "choice_b": "When immediate predictions are required for user-facing applications",
    "choice_c": "When you want to minimize compute costs for infrequent jobs",
    "choice_d": "When you have no strict latency requirements",
    "correct_answer": "B",
    "explanation": "Real-time endpoints offer low latency, making them ideal for interactive services or applications that demand immediate feedback.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      300,
      162
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 84,
    "question": "What is the primary benefit of shadow testing in the MLOps context?",
    "choice_a": "It completely replaces the current model in production.",
    "choice_b": "It allows you to test a new model on real traffic without affecting user responses.",
    "choice_c": "It permanently splits traffic between old and new models.",
    "choice_d": "It reduces the number of models you need to maintain.",
    "correct_answer": "B",
    "explanation": "Shadow testing routes a copy of real requests to the new model in parallel, letting you evaluate performance and detect issues before fully switching over.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      307,
      300,
      164,
      313,
      163
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 85,
    "question": "Why is continuous monitoring crucial for models in production?",
    "choice_a": "It helps reduce training time in the next iteration.",
    "choice_b": "It automatically labels new incoming data.",
    "choice_c": "It detects data drift and performance degradation over time.",
    "choice_d": "It eliminates the need for human oversight.",
    "correct_answer": "C",
    "explanation": "Continuous monitoring ensures models remain accurate and reliable by alerting teams to changes in data distribution or reduced performance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      307,
      300,
      299,
      164,
      103
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 86,
    "question": "Which inference optimization technique involves training a smaller, “student” model to replicate the behavior of a larger, “teacher” model?",
    "choice_a": "Quantization",
    "choice_b": "Pruning",
    "choice_c": "Model distillation",
    "choice_d": "Speculative decoding",
    "correct_answer": "C",
    "explanation": "Distillation transfers knowledge from a large, resource-intensive model to a smaller one, maintaining much of the original performance while reducing inference cost.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      332,
      132,
      333
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 87,
    "question": "When deploying multiple models on a single SageMaker endpoint, which approach allows them to share infrastructure and memory efficiently?",
    "choice_a": "Single-model endpoint with multiple replicas",
    "choice_b": "Multi-model endpoints, optionally leveraging Triton server",
    "choice_c": "Real-time endpoints with spot instances",
    "choice_d": "Asynchronous endpoint with blue/green deployment",
    "correct_answer": "B",
    "explanation": "Multi-model endpoints load models on demand, enabling multiple models to share the same endpoint infrastructure. Triton server optimizes GPU utilization and handles concurrent requests efficiently.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      326
    ],
    "source": "328192_Ch08"
  },
  {
    "id": 88,
    "question": "Which of the following responsible AI principles provides tools for bias detection, model quality monitoring, and explainability in machine learning models?",
    "choice_a": "Securely connect foundation models to your data sources for retrieval augmentation, thereby enhancing the model’s responses with relevant, context-specific information.",
    "choice_b": "Store and manage large datasets for training machine learning models.",
    "choice_c": "Provide bias detection, explainability, and model quality monitoring to ensure fairness and transparency in machine learning applications.",
    "choice_d": "Offer a development environment for building and testing machine learning algorithms.",
    "correct_answer": "C",
    "explanation": "Provide bias detection, explainability, and model quality monitoring to ensure fairness and transparency in machine learning applications.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      358,
      339,
      357,
      346,
      347
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 89,
    "question": "Which AWS service supports responsible AI by offering capabilities for bias detection, model quality monitoring, and explainability in machine learning models?",
    "choice_a": "Amazon SageMaker Clarify",
    "choice_b": "Amazon Bedrock Knowledge Bases",
    "choice_c": "AWS Lambda",
    "choice_d": "Amazon Redshift",
    "correct_answer": "A",
    "explanation": "Amazon SageMaker Clarify provides data and model monitoring capabilities that can help in bias detection.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      357,
      358,
      339,
      347,
      346
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 90,
    "question": "Which AWS service provides a centralized repository for managing, versioning, and approving machine learning models to ensure governance and streamlined deployment?",
    "choice_a": "Amazon SageMaker Clarify",
    "choice_b": "Amazon Bedrock Knowledge Bases",
    "choice_c": "AWS Lambda",
    "choice_d": "Amazon SageMaker Model Registry",
    "correct_answer": "D",
    "explanation": "Amazon SageMaker Model Registry enables organizations to track, version, approve, and manage machine learning models in a centralized repository, ensuring governance, compliance, and streamlined deployment.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      347,
      346,
      348
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 91,
    "question": "Which AWS service helps evaluate model quality for classification use cases by detecting bias in predictions and monitoring performance metrics such as accuracy and precision?",
    "choice_a": "AWS Lambda",
    "choice_b": "Amazon Bedrock Knowledge Bases",
    "choice_c": "Amazon SageMaker Clarify",
    "choice_d": "Amazon SageMaker Model Registry",
    "correct_answer": "C",
    "explanation": "Amazon SageMaker Clarify provides data and model monitoring capabilities that can help in bias detection.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      358,
      357,
      339,
      346,
      347
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 92,
    "question": "Why is model monitoring essential in machine learning applications?",
    "choice_a": "To automate data labeling and preprocessing tasks",
    "choice_b": "To detect model drift, ensure performance consistency, and identify bias in predictions over time",
    "choice_c": "To improve training speed and reduce computational costs",
    "choice_d": "To manage access control and security for machine learning models",
    "correct_answer": "B",
    "explanation": "Model monitoring is crucial for identifying data drift, performance degradation, and biases that may emerge over time in a deployed machine learning model. It helps maintain model accuracy, fairness, and reliability, ensuring that predictions remain relevant and aligned with business goals.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      358,
      339,
      346,
      357,
      347
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 93,
    "question": "Which of the following best describes the purpose of Amazon Bedrock evaluations in retrieval-augmented generation (RAG) use cases?",
    "choice_a": "To monitor infrastructure costs and optimize cloud resource usage",
    "choice_b": "To assess retrieval effectiveness and response accuracy, and to detect hallucinations in generated outputs",
    "choice_c": "To automate dataset labeling and improve model training efficiency",
    "choice_d": "To manage user access control and enforce security policies in AI applications",
    "correct_answer": "B",
    "explanation": "Amazon Bedrock evaluations for RAG use cases help measure how well the system retrieves relevant context, assess response correctness, and detect hallucinations in AI-generated outputs. These evaluations ensure that RAG applications provide accurate, reliable, and contextually relevant responses before deployment.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      371,
      370,
      363,
      339,
      357
    ],
    "source": "328192_Ch09"
  },
  {
    "id": 94,
    "question": "What is the primary responsibility of users in the AWS shared responsibility model for AI security?",
    "choice_a": "Managing the security of AWS data centers and core infrastructure",
    "choice_b": "Ensuring the security of data and applications within the cloud",
    "choice_c": "Conducting third-party audits of AWS compliance programs",
    "choice_d": "Monitoring AWS’s internal security controls",
    "correct_answer": "B",
    "explanation": "In the AWS shared responsibility model, AWS manages the security of the cloud infrastructure (e.g., data centers, networks), while users are responsible for securing their data and applications within the cloud, including how they use AWS services.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      374,
      417,
      403,
      410,
      382
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 95,
    "question": "Which framework provides a globally accessible knowledge base of adversary tactics and techniques specifically targeting AI-enabled systems?",
    "choice_a": "AWS Well-Architected Framework",
    "choice_b": "MITRE’s ATLAS",
    "choice_c": "ISO/IEC JTC 1/SC 42",
    "choice_d": "GDPR Compliance Framework",
    "correct_answer": "B",
    "explanation": "MITRE’s ATLAS (Adversarial Threat Landscape for Artificial-Intelligence Systems) is a knowledge base that documents real-world attack observations and techniques used against AI systems, helping organizations understand and mitigate AI-specific threats.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      375,
      376,
      377,
      380,
      378
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 96,
    "question": "Which of the following is a key requirement of the Health Insurance Portability and Accountability Act (HIPAA) for protecting electronic protected health information (ePHI)?",
    "choice_a": "Implementing administrative, physical, and technical safeguards",
    "choice_b": "Conducting annual security risk assessments and documenting findings",
    "choice_c": "Encrypting all ePHI during both transit and storage using AES-256",
    "choice_d": "Appointing a dedicated HIPAA compliance officer for organizations of any size",
    "correct_answer": "A",
    "explanation": "Options B, C, and D represent security practices that might seem correct, but they don’t fully capture the core HIPAA requirement. Option B is a component of HIPAA compliance but not the overarching requirement; C specifies a particular encryption method that HIPAA doesn’t mandate specifically; and D suggests a specific role requirement that isn’t precisely stated in HIPAA regulations.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      413,
      416,
      417,
      410,
      403
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 97,
    "question": "In the context of AI security, which of the following techniques involves modifying input data to deceive machine learning models into producing incorrect outputs, and is often used in adversarial attacks?",
    "choice_a": "Data augmentation",
    "choice_b": "Input perturbation",
    "choice_c": "Data normalization",
    "choice_d": "Feature extraction",
    "correct_answer": "B",
    "explanation": "Input perturbation (the revised term for adversarial data crafting) refers to the technique of deliberately introducing carefully calculated modifications to input data to deceive machine learning models, causing them to misclassify or produce incorrect outputs. This technique is commonly used in adversarial attacks to exploit vulnerabilities in AI systems.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      377,
      380,
      375,
      374,
      379
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 98,
    "question": "Which AWS service provides on-demand access to compliance reports, such as ISO certifications and SOC reports, to help organizations demonstrate the security and compliance of their AWS infrastructure?",
    "choice_a": "AWS Config",
    "choice_b": "AWS Audit Manager",
    "choice_c": "AWS Artifact",
    "choice_d": "AWS Key Management Service (KMS)",
    "correct_answer": "C",
    "explanation": "AWS Artifact provides on-demand access to AWS security and compliance documents, including ISO certifications, SOC reports, and PCI compliance reports, helping organizations demonstrate the security and compliance of their AWS infrastructure.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      416,
      417,
      415,
      414,
      410
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 99,
    "question": "Which of the following is a critical consideration when implementing data retention policies for generative AI applications to ensure compliance with regulations like GDPR?",
    "choice_a": "Implementing periodic reviews of stored data with automatic archiving of older datasets",
    "choice_b": "Establishing different retention timeframes based on data classification and business value",
    "choice_c": "Adhering to the principle of data minimization and retaining data only as long as necessary",
    "choice_d": "Documenting consent for each data use case with clear retention timelines communicated to users",
    "correct_answer": "C",
    "explanation": "Option C specifically addresses the core GDPR principle of data minimization. Options A, B, and D are good practices that might be part of a compliance program, but don’t directly address the fundamental principle that GDPR emphasizes regarding data retention limitations.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      402,
      412,
      410,
      401,
      399
    ],
    "source": "328192_Ch10"
  },
  {
    "id": 100,
    "question": "Which of the following describes a secure method to use LLMs on Amazon Bedrock?",
    "choice_a": "Design specific prompts and configure IAM with least privilege",
    "choice_b": "Use AWS Audit Manager for evaluation jobs",
    "choice_c": "Enable automatic evaluation in Amazon Bedrock",
    "choice_d": "Monitor bias with CloudWatch Logs",
    "correct_answer": "A",
    "explanation": "Using IAM with least privilege ensures controlled access and minimizes security risks while interacting with Amazon Bedrock. Well-designed prompts prevent data leakage and ensure the LLM responses stay within defined boundaries.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      403,
      378,
      374,
      380,
      410
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 101,
    "question": "Which AWS services help analyze customer sentiment from product reviews? (Choose two.)",
    "choice_a": "Amazon Lex",
    "choice_b": "Amazon Comprehend",
    "choice_c": "Amazon Polly",
    "choice_d": "Amazon Bedrock",
    "choice_e": "Amazon Rekognition",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Amazon Comprehend uses natural language processing to analyze text and extract sentiment, entities, and key phrases. Amazon Bedrock's foundation models can process and analyze text data, including customer reviews, to determine sentiment and insights.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      148,
      14,
      13,
      43,
      165
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 102,
    "question": "How can a company enrich an Amazon Titan model on Bedrock with private data?",
    "choice_a": "Use a different foundation model",
    "choice_b": "Lower the temperature value",
    "choice_c": "Create a knowledge base in Bedrock",
    "choice_d": "Enable model invocation logging",
    "correct_answer": "C",
    "explanation": "Knowledge bases in Bedrock allow company-specific data to be integrated with foundation models through RAG (Retrieval-Augmented Generation). This enables the model to access and incorporate private information while responding to queries, enhancing its relevance to specific business contexts.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      221,
      222,
      215,
      224,
      225
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 103,
    "question": "What should a company change to improve FM accuracy to a target level?",
    "choice_a": "Reduce the batch size",
    "choice_b": "Increase the number of training epochs",
    "choice_c": "Decrease the number of training epochs",
    "choice_d": "Increase the temperature setting",
    "correct_answer": "B",
    "explanation": "Increasing the training epochs allows the model to learn patterns more thoroughly from the training data. More epochs generally lead to better model accuracy, until reaching optimal convergence. Also, care must be taken to avoid overfitting.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      262,
      254,
      274,
      263,
      255
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 104,
    "question": "How can an AI practitioner prevent a Bedrock custom model from revealing confidential data?",
    "choice_a": "Delete the model and retrain without confidential data",
    "choice_b": "Use dynamic masking in the inference output",
    "choice_c": "Encrypt the output data with SageMaker",
    "choice_d": "Encrypt the model using AWS KMS",
    "correct_answer": "D",
    "explanation": "Using AWS KMS encryption protects the model and its data at rest, preventing unauthorized access to confidential information. Encryption ensures that sensitive data embedded within the model remains secure throughout its lifecycle in Bedrock.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      403,
      374,
      382,
      410,
      399
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 105,
    "question": "How can a marketing team align AI-generated content with brand messaging?",
    "choice_a": "Tune the model’s hyperparameters",
    "choice_b": "Add more model layers",
    "choice_c": "Use well-crafted prompts with context",
    "choice_d": "Pre-train a diverse new model",
    "correct_answer": "C",
    "explanation": "By using well-crafted prompts with context, marketers can guide AI models to generate content that closely aligns with the brand's specific messaging, tone, and voice. These detailed, nuanced prompts provide clear instructions and contextual information that help the AI understand and replicate the desired communication style.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      195,
      198,
      199,
      194,
      197
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 106,
    "question": "How can a company get consistent responses from an LLM in sentiment analysis?",
    "choice_a": "Decrease the temperature",
    "choice_b": "Increase the temperature",
    "choice_c": "Reduce the output token length",
    "choice_d": "Increase the max generation length",
    "correct_answer": "A",
    "explanation": "Decreasing the temperature parameter in an LLM makes the responses more consistent by reducing randomness and favoring the most probable tokens. This approach helps ensure more stable and predictable sentiment analysis results.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      185,
      186,
      199,
      197,
      187
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 107,
    "question": "How can a company deploy an image classification model without managing infrastructure?",
    "choice_a": "Use SageMaker Serverless Inference",
    "choice_b": "Use Amazon CloudFront",
    "choice_c": "Use API Gateway",
    "choice_d": "Use AWS Batch",
    "correct_answer": "A",
    "explanation": "SageMaker Serverless Inference allows companies to deploy image classification models without managing infrastructure, automatically scaling resources and handling computational needs. This approach simplifies deployment by removing the complexity of server provisioning and management.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      326,
      129,
      130
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 108,
    "question": "A Bedrock FM fails to access encrypted S3 data. What should be done?",
    "choice_a": "Ensure the Bedrock role has decryption permission",
    "choice_b": "Allow public access to the S3 bucket",
    "choice_c": "Use prompt engineering techniques",
    "choice_d": "Avoid storing sensitive data in S3",
    "correct_answer": "A",
    "explanation": "To enable a Bedrock Foundation Model to access encrypted S3 data, the associated IAM role must be granted explicit decryption permissions for the specific S3 bucket and its encrypted objects. This ensures that the model has the necessary cryptographic access rights to read and decrypt the protected data stored in S3.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      403,
      374,
      381
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 109,
    "question": "How can an AI practitioner store input/output data for a summarization model?",
    "choice_a": "Use CloudTrail",
    "choice_b": "Enable invocation logging in Bedrock",
    "choice_c": "Use Audit Manager",
    "choice_d": "Use EventBridge",
    "correct_answer": "B",
    "explanation": "Enabling invocation logging in Bedrock allows AI practitioners to automatically store and track input and output data from summarization models.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      400,
      403,
      410,
      399,
      402
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 110,
    "question": "Which AWS service lets a company upload a dataset to validate Bedrock FM outputs?",
    "choice_a": "Amazon S3",
    "choice_b": "Amazon EBS",
    "choice_c": "Amazon EFS",
    "choice_d": "AWS Snowcone",
    "correct_answer": "A",
    "explanation": "Amazon S3 enables a company to upload and store datasets for validating Bedrock Foundation Model outputs, providing a scalable and accessible cloud storage solution for model evaluation and testing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      293,
      225,
      205,
      262,
      221
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 111,
    "question": "How can a chatbot be restricted from returning inappropriate images?",
    "choice_a": "Implement Guardrails",
    "choice_b": "Retrain with public datasets",
    "choice_c": "Validate the model",
    "choice_d": "Use automated feedback",
    "correct_answer": "A",
    "explanation": "Implementing Guardrails in the chatbot system allows for setting explicit content filters and restrictions to prevent the generation of inappropriate images.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      380,
      379,
      378,
      410,
      382
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 112,
    "question": "What’s the simplest way to vary AI responses by user age in a Q&A app?",
    "choice_a": "Fine-tune for each age range",
    "choice_b": "Add an age role to the prompt",
    "choice_c": "Use chain-of-thought reasoning",
    "choice_d": "Summarize for each age group",
    "correct_answer": "B",
    "explanation": "Adding an age role to the prompt provides a simple and direct way to instruct the AI to generate age-appropriate responses in a Q&A application.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      198,
      195,
      194,
      199,
      201
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 113,
    "question": "How can LMs be deployed to edge devices with low latency?",
    "choice_a": "Use optimized SLMs on edge",
    "choice_b": "Use LLMs on edge",
    "choice_c": "Centralized SLM async API",
    "choice_d": "Centralized LLM async API",
    "correct_answer": "A",
    "explanation": "Using optimized Small Language Models (SLMs) on edge devices enables low-latency deployments by leveraging lightweight, compact models specifically designed for resource-constrained environments.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      332,
      132,
      326,
      333,
      129
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 114,
    "question": "Which AWS tool can generate sales graphs across retail locations?",
    "choice_a": "Amazon Q in EC2",
    "choice_b": "Amazon Q Developer",
    "choice_c": "Amazon Q in QuickSight",
    "choice_d": "Amazon Q in AWS Chatbot",
    "correct_answer": "C",
    "explanation": "Amazon Q in QuickSight enables automatic generation of sales graphs across retail locations by leveraging AI-powered data analysis and visualization capabilities.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      135,
      129,
      107
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 115,
    "question": "How can a company evaluate the accuracy of an FM used for image classification?",
    "choice_a": "Track resource costs",
    "choice_b": "Compare against a benchmark dataset",
    "choice_c": "Count model layers",
    "choice_d": "Assess image color accuracy",
    "correct_answer": "B",
    "explanation": "Comparing the Foundation Model's image classification results against a benchmark dataset allows a company to systematically evaluate its accuracy and performance.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      293,
      177,
      262,
      205,
      175
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 116,
    "question": "What responsible AI issue is represented by students copying AI-generated content?",
    "choice_a": "Toxicity",
    "choice_b": "Hallucinations",
    "choice_c": "Plagiarism",
    "choice_d": "Privacy",
    "correct_answer": "C",
    "explanation": "Plagiarism represents the responsible AI issue of students inappropriately copying and claiming AI-generated content as their own original work.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      339
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 117,
    "question": "What’s the lowest-overhead way to power a probability-based educational game?",
    "choice_a": "Use a regression model",
    "choice_b": "Use reinforcement learning",
    "choice_c": "Use simple rules and logic",
    "choice_d": "Use unsupervised learning",
    "correct_answer": "C",
    "explanation": "Using simple rules and logic provides the lowest-overhead approach to powering a probability-based educational game, minimizing computational complexity and resource requirements.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      95,
      5,
      37,
      36
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 118,
    "question": "What factor most impacts LLM inference cost in Bedrock?",
    "choice_a": "The number of tokens used",
    "choice_b": "The temperature setting",
    "choice_c": "The size of the training dataset",
    "choice_d": "The training duration",
    "correct_answer": "A",
    "explanation": "The number of tokens used during inference most directly impacts the cost of running Large Language Models in Amazon Bedrock, as token consumption drives computational resource utilization.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      133,
      130,
      62,
      332,
      129
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 119,
    "question": "What SageMaker feature supports variable sharing across model dev teams?",
    "choice_a": "Feature Store",
    "choice_b": "Data Wrangler",
    "choice_c": "Clarify",
    "choice_d": "Model Cards",
    "correct_answer": "A",
    "explanation": "SageMaker Feature Store enables teams to centrally manage, share, and reuse machine learning features across model development, promoting consistency and efficiency.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      327,
      326,
      135,
      106,
      129
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 120,
    "question": "What is a key benefit of FM fine-tuning compared to pre-training?",
    "choice_a": "Fine-tuning requires more computational resources than pre-training",
    "choice_b": "Fine-tuning requires less computational resources and data than pre-training",
    "choice_c": "Fine-tuning can only be done on small language models",
    "choice_d": "Fine-tuning always produces better results than pre-training",
    "correct_answer": "B",
    "explanation": "Fine-tuning requires less computational resources and data compared to pre-training, allowing more targeted and efficient model adaptation for specific tasks.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      248,
      276,
      264,
      176,
      262
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 121,
    "question": "How can data bias be addressed when generating images of professions?",
    "choice_a": "Augment imbalanced data",
    "choice_b": "Monitor class distributions",
    "choice_c": "Use Retrieval-Augmented Generation (RAG)",
    "choice_d": "Use watermark detection",
    "correct_answer": "A",
    "explanation": "Augmenting imbalanced data helps address bias by introducing diverse and representative images across different professional categories, reducing representation skews.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      339,
      357,
      358
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 122,
    "question": "What is a good metric to assess a model that classifies materials from image data?",
    "choice_a": "Confusion matrix",
    "choice_b": "Correlation matrix",
    "choice_c": "R2 score",
    "choice_d": "Mean squared error",
    "correct_answer": "A",
    "explanation": "A confusion matrix provides a comprehensive view of a model's performance in material classification, revealing true positives, true negatives, false positives, and false negatives.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      262,
      205,
      175
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 123,
    "question": "How should a company extract insights from recordings of calls from customers?",
    "choice_a": "Use Amazon Lex",
    "choice_b": "Use Amazon Transcribe",
    "choice_c": "Use Model Monitor",
    "choice_d": "Use Comprehend",
    "correct_answer": "B",
    "explanation": "Amazon Transcribe enables companies to convert customer call recordings into text, facilitating further analysis and insight extraction through natural language processing techniques.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      150,
      148,
      44,
      105,
      43
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 124,
    "question": "How can a company reduce LLM prompting costs with few-shot learning?",
    "choice_a": "Fine-tune the model",
    "choice_b": "Use fewer tokens in prompts",
    "choice_c": "Use more tokens in prompts",
    "choice_d": "Use provisioned throughput",
    "correct_answer": "B",
    "explanation": "Using fewer tokens in prompts reduces computational and cost overhead while maintaining model performance through efficient, few-shot learning techniques.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      203,
      199,
      196,
      194,
      200
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 125,
    "question": "Which AWS service helps deploy FMs in a VPC quickly?",
    "choice_a": "Amazon Personalize",
    "choice_b": "SageMaker JumpStart",
    "choice_c": "PartyRock",
    "choice_d": "SageMaker Endpoints",
    "correct_answer": "B",
    "explanation": "SageMaker JumpStart enables rapid deployment of Foundation Models within a Virtual Private Cloud (VPC) by providing pre-configured, easy-to-use machine learning solutions.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      326,
      129,
      130
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 126,
    "question": "What does Amazon Q Developer do to improve productivity?",
    "choice_a": "Creates code snippets with references",
    "choice_b": "Runs apps without servers",
    "choice_c": "Enables voice and NLP search",
    "choice_d": "Converts speech to text",
    "correct_answer": "A",
    "explanation": "Amazon Q Developer generates code snippets with contextual references, helping developers quickly write and understand code with AI-powered assistance.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      107,
      135,
      129,
      78
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 127,
    "question": "What are the different types of model customization supported on Amazon Bedrock? (Choose two.)",
    "choice_a": "Model distillation",
    "choice_b": "Pre-training foundation models",
    "choice_c": "Parameter efficient fine-tuning (PEFT) with LoRA",
    "choice_d": "Continued pre-training",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "On Amazon Bedrock, model customization can be achieved through model distillation and continued pre-training, allowing organizations to adapt Foundation Models to specific use cases with different techniques.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      276,
      263,
      248
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 128,
    "question": "Which AWS service allows Bedrock-based apps to stay offline?",
    "choice_a": "AWS PrivateLink",
    "choice_b": "Amazon Macie",
    "choice_c": "Amazon CloudFront",
    "choice_d": "Internet Gateway",
    "correct_answer": "A",
    "explanation": "AWS PrivateLink enables Bedrock-based applications to maintain secure, private connectivity without exposing traffic to the public Internet, supporting offline and isolated interactions.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      403
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 129,
    "question": "What two actions support responsible AI to reduce bias in loan decisions? (Choose two.)",
    "choice_a": "Detect imbalances in the data",
    "choice_b": "Ensure frequent model runs",
    "choice_c": "Evaluate the model’s behavior for transparency",
    "choice_d": "Use ROUGE metrics",
    "choice_e": "Check inference time",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Detecting data imbalances and evaluating the model's behavior for transparency help reduce bias in AI-driven loan decisions by identifying potential discriminatory patterns and ensuring fair algorithmic decision-making.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      339,
      357,
      358,
      346,
      347
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 130,
    "question": "What can be added to model reports to improve transparency?",
    "choice_a": "Training code",
    "choice_b": "Partial dependence plots (PDPs)",
    "choice_c": "Sample data",
    "choice_d": "Model convergence logs",
    "correct_answer": "B",
    "explanation": "Partial dependence plots (PDPs) provide visual insights into how specific features impact model predictions, enhancing transparency and interpretability of machine learning models.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      358,
      357,
      339,
      347
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 131,
    "question": "How can a model better handle complex scientific terms?",
    "choice_a": "Few-shot prompting",
    "choice_b": "Domain adaptation fine-tuning",
    "choice_c": "Change the inference parameters",
    "choice_d": "Clean the data",
    "correct_answer": "B",
    "explanation": "Domain adaptation fine-tuning enables a model to better understand and handle complex scientific terms by training on specialized, domain-specific datasets.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      263,
      262,
      248,
      276,
      286
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 132,
    "question": "Which method ensures high accuracy for labeling image datasets for computer vision models?",
    "choice_a": "Employ human-in-the-loop with Ground Truth Plus",
    "choice_b": "Augment data via Bedrock KB",
    "choice_c": "Use Rekognition",
    "choice_d": "Summarize with QuickSight",
    "correct_answer": "A",
    "explanation": "Employing human-in-the-loop with Amazon Ground Truth Plus ensures high accuracy in labeling image datasets by combining AI assistance with expert human verification.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      164,
      41,
      104,
      163,
      306
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 133,
    "question": "What model can generate synthetic data?",
    "choice_a": "GAN",
    "choice_b": "XGBoost",
    "choice_c": "ResNet",
    "choice_d": "WaveNet",
    "correct_answer": "A",
    "explanation": "Generative Adversarial Networks (GANs) can generate synthetic data by training two neural networks—a generator and a discriminator—to create realistic, artificial datasets.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      69,
      106,
      82
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 134,
    "question": "What metric would best evaluate a plant disease classification model?",
    "choice_a": "R-squared",
    "choice_b": "Accuracy",
    "choice_c": "RMSE",
    "choice_d": "Learning rate",
    "correct_answer": "B",
    "explanation": "Accuracy provides a straightforward measure of overall performance for a plant disease classification model, indicating the percentage of correctly identified plant disease instances.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      262,
      205,
      294,
      276
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 135,
    "question": "Which service can extract text from PDF résumés?",
    "choice_a": "Amazon Textract",
    "choice_b": "Amazon Personalize",
    "choice_c": "Amazon Lex",
    "choice_d": "Amazon Transcribe",
    "correct_answer": "A",
    "explanation": "Amazon Textract enables automatic text extraction from PDF résumés, facilitating efficient document processing and data retrieval for HR and recruitment applications.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      131,
      135,
      134,
      130,
      106
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 136,
    "question": "Which learning method helps chatbots improve based on past interactions?",
    "choice_a": "Supervised learning with curated data",
    "choice_b": "Reinforcement learning with feedback",
    "choice_c": "Unsupervised clustering",
    "choice_d": "Supervised learning with updated FAQs",
    "correct_answer": "B",
    "explanation": "Reinforcement learning with user feedback allows chatbots to continuously improve their responses by learning from past interactions and adapting their behavior based on user input.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      8,
      90
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 137,
    "question": "What does SageMaker Clarify help identify? (Choose two.)",
    "choice_a": "RAG pipelines",
    "choice_b": "Insights into how models make predictions",
    "choice_c": "Model quality drift",
    "choice_d": "Bias in training data and model predictions",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "SageMaker Clarify helps identify model quality drift and potential biases in both training data and model predictions, supporting more transparent and fair machine learning practices.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      358,
      357,
      339
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 138,
    "question": "Which Bedrock pricing model is flexible and commitment-free?",
    "choice_a": "On-demand",
    "choice_b": "Model customization",
    "choice_c": "Provisioned throughput",
    "choice_d": "Spot instance",
    "correct_answer": "A",
    "explanation": "On-demand pricing in Amazon Bedrock provides a flexible, commitment-free model that allows users to pay only for the actual computational resources consumed during Foundation Model usage.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      133,
      130,
      129
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 139,
    "question": "How can SageMaker Studio access S3 securely?",
    "choice_a": "By using Amazon Inspector",
    "choice_b": "By using Macie",
    "choice_c": "By using a VPC and an S3 endpoint",
    "choice_d": "By using S3 Glacier Deep Archive",
    "correct_answer": "C",
    "explanation": "Using a VPC and an S3 endpoint enables SageMaker Studio to access S3 buckets securely through a private network connection, minimizing exposure to the public Internet.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      403,
      382,
      399,
      374,
      400
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 140,
    "question": "Which EC2 instance is best for energy-efficient LLM training?",
    "choice_a": "EC2 C",
    "choice_b": "EC2 G",
    "choice_c": "EC2 P",
    "choice_d": "EC2 Trn (Trainium)",
    "correct_answer": "D",
    "explanation": "EC2 Trainium (Trn) instances are specifically designed for energy-efficient and high-performance machine learning training and are particularly optimized for Large Language Models.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      332,
      67,
      132,
      69,
      62
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 141,
    "question": "What method ensures that a chatbot’s responses reflect the preferred tone of a brand?",
    "choice_a": "Limiting the token output",
    "choice_b": "Using batch inference",
    "choice_c": "Refining the prompt design",
    "choice_d": "Increasing the temperature setting",
    "correct_answer": "C",
    "explanation": "Refining the prompt design allows precise control over a chatbot's tone by incorporating specific language, style, and brand voice guidelines into the initial instruction set.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      194,
      198,
      195,
      199,
      201
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 142,
    "question": "What solution can support explainable AI in medical diagnostics?",
    "choice_a": "Amazon Inspector",
    "choice_b": "SageMaker Clarify",
    "choice_c": "AWS Macie",
    "choice_d": "Rekognition",
    "correct_answer": "B",
    "explanation": "SageMaker Clarify provides interpretability tools that help explain AI model predictions in medical diagnostics, offering insights into how decisions are made and supporting transparency.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      358,
      357,
      339,
      347
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 143,
    "question": "Which service tracks unauthorized access to Bedrock?",
    "choice_a": "Audit Manager",
    "choice_b": "CloudTrail",
    "choice_c": "Fraud Detector",
    "choice_d": "Trusted Advisor",
    "correct_answer": "B",
    "explanation": "CloudTrail tracks and logs unauthorized access attempts to Amazon Bedrock, providing comprehensive monitoring and security auditing for Foundation Model interactions.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      403,
      400,
      374,
      414,
      410
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 144,
    "question": "Which inference type suits large inputs with long runtimes?",
    "choice_a": "Real-time",
    "choice_b": "Serverless",
    "choice_c": "Async",
    "choice_d": "Batch transform",
    "correct_answer": "C",
    "explanation": "Async inference is ideal for handling large inputs with long processing times, allowing flexible and efficient processing of computationally intensive machine learning tasks.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      201,
      264,
      203,
      255,
      238
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 145,
    "question": "What AI process is performed when a model labels objects in a set of new images?",
    "choice_a": "Training",
    "choice_b": "Inference",
    "choice_c": "Deployment",
    "choice_d": "Bias correction",
    "correct_answer": "B",
    "explanation": "Inference is the process where a trained machine learning model applies its learned knowledge to label or classify objects in new, unseen images.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      55,
      307,
      54,
      163,
      300
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 146,
    "question": "What type of model can predict missing words in broken documents?",
    "choice_a": "Topic model",
    "choice_b": "Clustering",
    "choice_c": "Foundation Models",
    "choice_d": "PERT model",
    "correct_answer": "C",
    "explanation": "Foundation Models can predict missing words in broken documents by leveraging their extensive pre-training on diverse textual data and contextual understanding.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      67,
      66,
      62,
      106,
      59
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 147,
    "question": "What AWS service can notify users when compliance reports are ready?",
    "choice_a": "AWS Audit Manager",
    "choice_b": "AWS Artifact",
    "choice_c": "Trusted Advisor",
    "choice_d": "Data Exchange",
    "correct_answer": "B",
    "explanation": "AWS Artifact is Amazon's compliance reports hub that provides on-demand access to AWS security and compliance reports. It has a notification feature that automatically alerts users when new compliance reports and agreements become available.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      416,
      417,
      415
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 148,
    "question": "What AWS tool helps forecast demand without coding ML?",
    "choice_a": "SageMaker built-in + S3",
    "choice_b": "Data Wrangler + built-ins",
    "choice_c": "Data Wrangler + Personalize",
    "choice_d": "SageMaker Canvas",
    "correct_answer": "D",
    "explanation": "SageMaker Canvas enables users to create machine learning models for demand forecasting without coding, providing an intuitive, no-code interface for predictive analytics.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      129
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 149,
    "question": "What are tokens in generative AI?",
    "choice_a": "Units of input/output",
    "choice_b": "Math representations",
    "choice_c": "Pre-trained weights",
    "choice_d": "Prompts or instructions",
    "correct_answer": "A",
    "explanation": "Tokens in generative AI are discrete units of input and output, representing chunks of text or data that models process and generate during language-related tasks.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      62,
      66,
      67,
      68,
      59
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 150,
    "question": "Which solution can help a law firm extract key points from legal documents?",
    "choice_a": "Building a named entity recognition system",
    "choice_b": "Creating a recommendation engine",
    "choice_c": "Developing a summarization chatbot",
    "choice_d": "Building a translation system",
    "correct_answer": "C",
    "explanation": "A summarization chatbot can help a law firm efficiently extract key points from legal documents by leveraging AI to condense and highlight critical information.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      107,
      131,
      59,
      78,
      130
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 151,
    "question": "What is a common use case for generative AI in marketing?",
    "choice_a": "Intrusion detection",
    "choice_b": "Generating photorealistic images from text",
    "choice_c": "Database indexing",
    "choice_d": "Financial forecasting",
    "correct_answer": "B",
    "explanation": "Generating photorealistic images from text descriptions is a common use case for generative AI in marketing, enabling creative visual content production without traditional photography.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      69,
      106,
      68,
      59,
      107
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 152,
    "question": "Which type of ML model explains its predictions while performing a classification task?",
    "choice_a": "Decision trees",
    "choice_b": "Linear regression",
    "choice_c": "Logistic regression",
    "choice_d": "Neural networks",
    "correct_answer": "A",
    "explanation": "Decision trees provide interpretable predictions by breaking down classification tasks into a series of transparent, hierarchical decision nodes that can be easily explained.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      358,
      339,
      357
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 153,
    "question": "What term describes numerical vectors in NLP models?",
    "choice_a": "Embeddings",
    "choice_b": "Tokens",
    "choice_c": "Models",
    "choice_d": "Binaries",
    "correct_answer": "A",
    "explanation": "Embeddings are numerical vector representations of words or tokens in natural language processing models. They capture semantic relationships and contextual meanings.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      43,
      13,
      105,
      103,
      9
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 154,
    "question": "If a security model shows ethnic bias, what type of bias is this?",
    "choice_a": "Measurement bias",
    "choice_b": "Sampling bias",
    "choice_c": "Observer bias",
    "choice_d": "Confirmation bias",
    "correct_answer": "B",
    "explanation": "Sampling bias occurs when the training data does not represent the entire population equally, leading to skewed and potentially discriminatory model predictions.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      339,
      357,
      358
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 155,
    "question": "Which capabilities support compliance for a SageMaker JumpStart chatbot? (Choose two.)",
    "choice_a": "Auto-scaling endpoints",
    "choice_b": "Threat detection",
    "choice_c": "Data protection",
    "choice_d": "Cost optimization",
    "choice_e": "Loosely coupled microservices",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "SageMaker JumpStart supports compliance through auto-scaling endpoints that manage deployment and data protection mechanisms, ensuring secure and adaptable chatbot implementations.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      410,
      399,
      382,
      403,
      374
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 156,
    "question": "How can teams on Bedrock access only their customer data?",
    "choice_a": "Create a separate service role per team",
    "choice_b": "Use a shared role with customer names",
    "choice_c": "Redact sensitive data in S3",
    "choice_d": "Use one S3 role and separate IAM roles per team",
    "correct_answer": "D",
    "explanation": "Using one S3 role with separate IAM roles per team enables granular access control, allowing each team to access only their specific customer data within a shared storage environment.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      403,
      410,
      374,
      400
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 157,
    "question": "What’s the most cost-effective way to build a PDF-based chatbot?",
    "choice_a": "Add one PDF as prompt context",
    "choice_b": "Add all PDFs to the prompt",
    "choice_c": "Fine-tune a model with the PDFs",
    "choice_d": "Upload PDFs to a Bedrock knowledge base",
    "correct_answer": "D",
    "explanation": "Uploading PDFs to a Bedrock knowledge base provides a cost-effective and efficient method for building a PDF-based chatbot with dynamic, easily updatable information retrieval.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      131,
      130,
      133,
      129,
      107
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 158,
    "question": "Which metric can best evaluate the accuracy of a translation?",
    "choice_a": "BLEU",
    "choice_b": "RMSE",
    "choice_c": "ROUGE",
    "choice_d": "F1 Score",
    "correct_answer": "A",
    "explanation": "The BLEU (Bilingual Evaluation Understudy) score is a widely used metric for evaluating the accuracy of machine translation by comparing machine-generated translations to human references.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      293,
      262,
      175
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 159,
    "question": "What solution detects if an IP address is suspicious?",
    "choice_a": "Speech recognition model",
    "choice_b": "Named entity recognition",
    "choice_c": "Anomaly detection system",
    "choice_d": "Fraud forecasting engine",
    "correct_answer": "C",
    "explanation": "An anomaly detection system can identify suspicious IP addresses by analyzing network traffic patterns and flagging deviations from expected behavior.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      41,
      102,
      5,
      90
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 160,
    "question": "How can a company stop Bedrock outputs from including personal information?",
    "choice_a": "Use Macie",
    "choice_b": "Use CloudTrail",
    "choice_c": "Use Guardrails for Bedrock",
    "choice_d": "Use Model Monitor",
    "correct_answer": "C",
    "explanation": "Guardrails for Bedrock provides content filtering and safety controls that prevent the generation of outputs containing sensitive or personal information.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      380,
      379,
      378,
      410,
      374
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 161,
    "question": "Creating correlation plots and statistics on training data falls under which ML stage?",
    "choice_a": "Data preprocessing",
    "choice_b": "Feature engineering",
    "choice_c": "Exploratory data analysis",
    "choice_d": "Hyperparameter tuning",
    "correct_answer": "C",
    "explanation": "Exploratory data analysis involves creating correlation plots and statistical summaries to understand dataset characteristics, patterns, and relationships before model training.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      306,
      163,
      42
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 162,
    "question": "How can you ensure safe AI content when generating child-friendly stories?",
    "choice_a": "Amazon Rekognition",
    "choice_b": "Bedrock Playground",
    "choice_c": "Guardrails for Bedrock",
    "choice_d": "Bedrock Agents",
    "correct_answer": "C",
    "explanation": "Guardrails for Bedrock enables content filtering and safety controls to ensure child-friendly language and prevent inappropriate content generation in AI-generated stories.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      380,
      410,
      378,
      379,
      374
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 163,
    "question": "Which type of model handles both image and text inputs in queries?",
    "choice_a": "Multi-modal embedding model",
    "choice_b": "Text embedding model",
    "choice_c": "Multi-modal generation model",
    "choice_d": "Image generation model",
    "correct_answer": "C",
    "explanation": "Multi-modal generation models can process and generate content using both image and text inputs, enabling more complex and versatile AI interactions.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      68,
      69,
      78,
      106,
      59
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 164,
    "question": "What’s the benefit of using Bedrock agents for customer service automation?",
    "choice_a": "They generate custom FMs",
    "choice_b": "They automate tasks and workflows",
    "choice_c": "They invoke multiple FMs",
    "choice_d": "They pick FMs based on metrics",
    "correct_answer": "B",
    "explanation": "Bedrock agents automate customer service tasks and workflows by enabling intelligent, context-aware interactions that streamline complex service processes.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      131,
      133,
      107,
      129,
      59
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 165,
    "question": "Which method can categorize animals in photos?",
    "choice_a": "Object detection",
    "choice_b": "Anomaly detection",
    "choice_c": "Named entity recognition",
    "choice_d": "Inpainting",
    "correct_answer": "A",
    "explanation": "Object detection enables the categorization of animals in photos by identifying, classifying, and localizing specific animal types within image data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      44,
      12,
      103,
      9
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 166,
    "question": "Which solution scope in the AI Security Matrix gives customers the most responsibility?",
    "choice_a": "Enterprise apps with embedded AI",
    "choice_b": "Using third-party FMs",
    "choice_c": "Fine-tuning third-party FMs",
    "choice_d": "Building and training FMs from scratch",
    "correct_answer": "D",
    "explanation": "Building and training Foundation Models from scratch gives customers the most responsibility in the AI Security Matrix, requiring comprehensive control and management of the entire model-development process.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      382,
      381,
      374,
      399,
      410
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 167,
    "question": "Which strategy adapts pre-trained models to new tasks without starting over?",
    "choice_a": "Increasing the number of epochs",
    "choice_b": "Using transfer learning",
    "choice_c": "Decreasing the number of epochs",
    "choice_d": "Using unsupervised learning",
    "correct_answer": "B",
    "explanation": "Transfer learning enables adapting pre-trained models to new tasks by leveraging learned features from the original training, reducing the need to develop models from scratch.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      248,
      262,
      276,
      264,
      274
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 168,
    "question": "A model performs well during training but poorly in production. What’s the fix?",
    "choice_a": "Reduce the amount of training data",
    "choice_b": "Add hyperparameters to the model",
    "choice_c": "Increase the amount of training data",
    "choice_d": "Train the model for longer",
    "correct_answer": "C",
    "explanation": "Increasing the amount of training data helps address model performance issues by providing more diverse and representative examples, reducing overfitting and improving generalization to production scenarios.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      10,
      5,
      306,
      12,
      307
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 169,
    "question": "What prompt engineering approach helps classify sentiment accurately?",
    "choice_a": "Adding labeled examples",
    "choice_b": "Describing sentiment in the prompt",
    "choice_c": "Using new text only",
    "choice_d": "Using unrelated examples",
    "correct_answer": "A",
    "explanation": "Adding labeled examples in the prompt helps improve sentiment classification accuracy by providing clear context and demonstrating the desired classification approach.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      199,
      200,
      195,
      248,
      202
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 170,
    "question": "Which method is best to classify unlabeled customers into segments?",
    "choice_a": "Supervised learning",
    "choice_b": "Unsupervised learning",
    "choice_c": "Reinforcement learning",
    "choice_d": "RLHF",
    "correct_answer": "B",
    "explanation": "Unsupervised learning enables customer segmentation by automatically discovering patterns and grouping unlabeled data based on inherent similarities without pre-defined classifications.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      6,
      102,
      41,
      8
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 171,
    "question": "How can a company get shorter, language-specific responses from an LLM?",
    "choice_a": "Adjust the prompt",
    "choice_b": "Use a different model size",
    "choice_c": "Increase temperature",
    "choice_d": "Increase Top-K",
    "correct_answer": "A",
    "explanation": "Adjusting the prompt by specifying desired response length and language-specific requirements helps an LLM generate more concise, targeted responses.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      196,
      194,
      175,
      195,
      197
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 172,
    "question": "What’s required to fine-tune a Bedrock model for improved search?",
    "choice_a": "Using labeled prompt-response pairs",
    "choice_b": "Including text files in CSV",
    "choice_c": "Using provisioned throughput",
    "choice_d": "Training the model on books and journals",
    "correct_answer": "A",
    "explanation": "Using labeled prompt-response pairs enables fine-tuning a Bedrock model for improved search by providing specific examples that guide the model's understanding and response generation.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      276,
      262,
      248,
      286,
      264
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 173,
    "question": "When a company wants to evaluate different AI language models for their ability to match or adapt to their employees’ specific writing style and tone, what is the most effective evaluation approach?",
    "choice_a": "Use built-in datasets provided by model vendors",
    "choice_b": "Conduct human evaluation with custom prompts based on company content",
    "choice_c": "Rely on public leaderboards and benchmark scores",
    "choice_d": "Analyze CloudWatch latency metrics for performance comparison",
    "correct_answer": "B",
    "explanation": "Conducting human evaluation with custom prompts based on company content allows for a direct, context-specific assessment of how well AI language models can match the organization's unique writing style and tone.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      293,
      294,
      205,
      199,
      174
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 174,
    "question": "Which metric best measures the impact of an LLM chatbot on a call center?",
    "choice_a": "Website engagement",
    "choice_b": "Average call duration",
    "choice_c": "Corporate responsibility",
    "choice_d": "Regulatory compliance",
    "correct_answer": "B",
    "explanation": "Average call duration serves as a key metric for evaluating an LLM chatbot's impact on a call center, reflecting its efficiency at resolving customer inquiries and potentially reducing interaction time.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      294,
      177,
      176,
      174,
      203
    ],
    "source": "328192_PracticeTest1"
  },
  {
    "id": 175,
    "question": "A company has a large amount of database data and wants to create an AI system that translates natural language into SQL. What should they use?",
    "choice_a": "Transformers-based generative models",
    "choice_b": "Residual neural network",
    "choice_c": "Support vector machine",
    "choice_d": "Deep Learning models",
    "correct_answer": "A",
    "explanation": "Transformers-based generative models excel at translating natural language into SQL by leveraging their advanced contextual understanding and sequence-to-sequence learning capabilities.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      67,
      66,
      107,
      59,
      62
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 176,
    "question": "Which actions would support responsible AI practices for an accounting firm using LLMs for document processing? (Choose two.)",
    "choice_a": "Including fairness metrics",
    "choice_b": "Adjusting the temperature parameter",
    "choice_c": "Modifying training data to mitigate bias",
    "choice_d": "Avoiding overfitting",
    "choice_e": "Applying prompt engineering techniques",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Including fairness metrics and modifying training data to mitigate bias help accounting firms implement responsible AI practices, ensuring ethical and equitable document processing using LLMs.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      339,
      357,
      358,
      347,
      346
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 177,
    "question": "A financial technology company needs to implement real-time fraud detection that processes thousands of transactions per second with maximum 100 ms latency. Which approach should they implement?",
    "choice_a": "Deploy on SageMaker serverless endpoints with asynchronous message queue processing",
    "choice_b": "Use AWS Lambda functions with embedded models triggered per transaction",
    "choice_c": "Deploy on SageMaker with dedicated low-latency instances and direct API integration",
    "choice_d": "Process streams with Kinesis Data Analytics and run batch inference every five minutes",
    "correct_answer": "C",
    "explanation": "Deploying on SageMaker with dedicated low-latency instances and direct API integration enables financial technology companies to process thousands of transactions per second with minimal latency, supporting real-time fraud detection requirements.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      326,
      327,
      332,
      129
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 178,
    "question": "A regulatory compliance company uses Amazon Bedrock to automatically summarize lengthy investment reports for their clients. The company needs to evaluate how accurately these AI-generated summaries capture the key information and meaning from the original documents. Which metric would be most appropriate for assessing the quality of these summaries?",
    "choice_a": "BERTScore",
    "choice_b": "RMSE",
    "choice_c": "Detoxify algorithm",
    "choice_d": "MAPE",
    "correct_answer": "A",
    "explanation": "A BERTScore provides an effective metric for evaluating AI-generated summaries by assessing semantic similarity and contextual understanding between the original investment reports and their AI-generated summaries.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      293,
      225,
      177,
      205
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 252,
    "question": "A specialty food company wants to automatically generate customized product descriptions for more than 5,000 products using existing product attributes. Which approach is most effective at this scale?",
    "choice_a": "Use Amazon Bedrock batch inference with a reusable prompt template populated with each product's attributes",
    "choice_b": "Store the product information in a data lake and use fixed text templates without a foundation model",
    "choice_c": "Require an employee to manually write or approve every product description",
    "choice_d": "Use an Amazon Bedrock Knowledge Base only to retrieve the existing product information",
    "correct_answer": "A",
    "explanation": "Amazon Bedrock batch inference can process a large set of prompts asynchronously. A reusable prompt template populated with each product's attributes enables a foundation model to generate customized descriptions consistently and efficiently. A Knowledge Base can retrieve source information for a RAG workflow, but retrieval alone does not generate the descriptions and is unnecessary when the required attributes are already supplied in each prompt.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      203,
      199,
      194,
      201,
      195
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 180,
    "question": "A pharmaceutical company has collected millions of unlabeled medical documents and research papers. They want to adapt a foundation model to better understand domain-specific terminology and relationships in pharmaceutical research without manually labeling the data. Which approach should they use?",
    "choice_a": "Fine-tuning",
    "choice_b": "Retrieval-Augmented Generation (RAG)",
    "choice_c": "Continued pre-training",
    "choice_d": "Prompt engineering",
    "correct_answer": "C",
    "explanation": "Continued pre-training allows the pharmaceutical company to adapt a foundation model to domain-specific medical terminology by further training on their extensive collection of unlabeled research documents, improving the model's understanding without manual labeling.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      263,
      276,
      248,
      253,
      286
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 181,
    "question": "A scientific publisher needs to implement an AI solution that can summarize lengthy academic research papers (often 40–50 pages) in a single operation without splitting the documents. Which foundation model characteristic is most critical for successfully accomplishing this task?",
    "choice_a": "Vocabulary size",
    "choice_b": "Model complexity",
    "choice_c": "Model latency",
    "choice_d": "Context window",
    "correct_answer": "D",
    "explanation": "The context window size is critical for summarizing lengthy academic research papers, as it determines the model's ability to process and comprehend entire documents in a single operation without document splitting.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      194,
      201,
      175,
      174,
      185
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 182,
    "question": "What indicates that a deep learning model is overfitting?",
    "choice_a": "A small gap between its training and testing accuracy",
    "choice_b": "A large gap between its training and testing accuracy",
    "choice_c": "Low computational cost",
    "choice_d": "High computational cost",
    "correct_answer": "B",
    "explanation": "A large gap between training and testing accuracy indicates overfitting, where a model performs exceptionally well on training data but fails to generalize effectively to new, unseen data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      292,
      307,
      11,
      5
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 183,
    "question": "An e-commerce retailer wants to implement an ML-based demand forecasting system to optimize inventory levels across their 50 regional warehouses. The system needs to predict product demand for the next three months to prevent stockouts while minimizing excess inventory. Which type of data would be most appropriate as the primary input for this forecasting application?",
    "choice_a": "Unstructured data (customer reviews, product descriptions, and social media mentions)",
    "choice_b": "Time-series data (historical sales volumes with timestamps, seasonal patterns, and trends)",
    "choice_c": "Labeled data (product attributes with manually assigned demand classifications)",
    "choice_d": "Unlabeled data (customer browsing behaviors and inventory movements without targets)",
    "correct_answer": "B",
    "explanation": "Time-series data, including historical sales volumes, timestamps, and seasonal patterns, provides the most appropriate input for an ML-based demand forecasting system, enabling accurate predictions of product demand across regional warehouses.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      42,
      90,
      100,
      306,
      8
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 184,
    "question": "A healthcare technology company needs to evaluate potential bias in their LLM that generates patient education materials across diverse populations. They want to implement a systematic assessment approach with minimal administrative overhead. Which data source would be most effective for this purpose?",
    "choice_a": "User-generated content",
    "choice_b": "Moderation logs",
    "choice_c": "Content guidelines (company documentation on inclusive language policies)",
    "choice_d": "Benchmark datasets (standardized collections of prompts designed to reveal model biases)",
    "correct_answer": "D",
    "explanation": "Benchmark datasets provide a systematic and standardized approach for evaluating potential biases in an LLM generating patient education materials, offering predefined prompts that can reveal hidden biases across diverse populations.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      293,
      205,
      175,
      294
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 185,
    "question": "A retail analytics company needs to process 500 GB of historical customer transaction data to generate purchase recommendations for their upcoming seasonal campaign. The predictions aren’t time-sensitive and can be completed within 24 hours. Which Amazon SageMaker inference option is most appropriate for this workload?",
    "choice_a": "Batch transform",
    "choice_b": "Real-time inference",
    "choice_c": "Serverless inference",
    "choice_d": "Asynchronous inference",
    "correct_answer": "A",
    "explanation": "Batch transform is most appropriate for processing large volumes of historical transaction data for non-time-sensitive recommendation generation, efficiently handling the 500 GB dataset within a 24-hour window.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      326
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 186,
    "question": "A financial services company is implementing few-shot learning to improve their customer service chatbot’s ability to recognize unusual account inquiries without extensive retraining. To create effective few-shot examples that will help the model better detect customer intents on the fly, what specific combination of data elements must they provide?",
    "choice_a": "Chatbot responses and user intents",
    "choice_b": "User messages and chatbot responses",
    "choice_c": "User messages and correct intents",
    "choice_d": "Intents and chatbot responses",
    "correct_answer": "C",
    "explanation": "User messages and their corresponding correct intents are crucial for creating effective few-shot learning examples, enabling the customer service chatbot to accurately recognize and interpret unusual account inquiries.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      199,
      200,
      248
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 187,
    "question": "A recommendation engine startup wants to build a product similarity system that converts item descriptions into vector embeddings and finds related products based on semantic meaning rather than keywords. Which specific Amazon OpenSearch feature enables this vector database application?",
    "choice_a": "S3 integration for storing embedding files",
    "choice_b": "Geospatial indexing for multidimensional mapping",
    "choice_c": "Scalable index with k-NN algorithm for vector similarity",
    "choice_d": "Real-time streaming for continuous embedding updates",
    "correct_answer": "C",
    "explanation": "OpenSearch's scalable index with k-NN (k-Nearest Neighbors) algorithm enables the recommendation engine to efficiently convert product descriptions into vector embeddings and find semantically similar items based on their vector representations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 188,
    "question": "A healthcare company using an LLM for patient queries needs to protect against malicious users attempting to extract unauthorized information or bypass ethical guidelines. Which approach best prevents prompt injection attacks?",
    "choice_a": "By teaching the LLM to detect attack prompts through adversarial training",
    "choice_b": "By increasing the temperature setting to add randomness to responses",
    "choice_c": "By avoiding unsupported foundation models without security certifications",
    "choice_d": "By limiting the input tokens to reduce attack surface",
    "correct_answer": "A",
    "explanation": "Adversarial training enables the LLM to detect and resist prompt injection attacks by teaching the model to recognize and reject malicious attempts to extract unauthorized information or bypass ethical guidelines.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      380,
      378,
      375,
      374
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 189,
    "question": "What determines how much input a prompt can handle in Bedrock?",
    "choice_a": "Temperature",
    "choice_b": "Context window",
    "choice_c": "Batch size",
    "choice_d": "Model size",
    "correct_answer": "B",
    "explanation": "The context window determines how much input a prompt can handle in Amazon Bedrock, defining the maximum number of tokens or characters that can be processed in a single interaction.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      194,
      201,
      185,
      203,
      175
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 190,
    "question": "What issue occurs when an LLM outputs plausible but incorrect content?",
    "choice_a": "Data leakage",
    "choice_b": "Hallucinations",
    "choice_c": "Overfitting",
    "choice_d": "Underfitting",
    "correct_answer": "B",
    "explanation": "Hallucinations occur when an LLM generates plausible-sounding but factually incorrect content, presenting confidently fabricated information that appears credible but lacks actual truth.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      82,
      131,
      78,
      132,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 191,
    "question": "A marketing team needs to analyze customer data stored in their database but most team members lack technical SQL expertise. They need a solution that can automatically convert plain English questions into accurate SQL queries. Which AI solution is best suited for this natural language to SQL conversion task?",
    "choice_a": "Large language models with text-to-SQL capabilities",
    "choice_b": "Computer vision models with transfer learning",
    "choice_c": "Traditional NLP with rule-based parsing",
    "choice_d": "Time series forecasting algorithms",
    "correct_answer": "A",
    "explanation": "Large language models (LLMs) with text-to-SQL capabilities can effectively translate plain English questions into accurate SQL queries, enabling marketing team members without technical SQL expertise to easily query their customer database.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      130,
      59,
      107,
      78,
      131
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 192,
    "question": "A global retail company wants to ensure their customer service AI chatbot provides inclusive, fair responses to all users regardless of background. Which approach would most effectively address potential bias in the chatbot’s outputs?",
    "choice_a": "Using diverse, representative training datasets",
    "choice_b": "Implementing Amazon Fraud Detector",
    "choice_c": "Creating standardized prompt templates",
    "choice_d": "Deploying RAG with specialized agents",
    "correct_answer": "A",
    "explanation": "Using diverse, representative training datasets helps ensure that the customer service AI chatbot provides inclusive and fair responses by exposing the model to a wide range of perspectives and communication styles across different backgrounds.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      339,
      357,
      358,
      370,
      347
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 193,
    "question": "A company has used multiple foundation models in Amazon Bedrock to generate patient education materials. They need to systematically compare these models’ performance before selecting one for production. Which Amazon Bedrock feature allows them to create structured evaluation workflows with custom human feedback?",
    "choice_a": "Model Evaluation Jobs",
    "choice_b": "Guardrails",
    "choice_c": "Knowledge Base",
    "choice_d": "Model Invocation Metrics",
    "correct_answer": "A",
    "explanation": "Model Evaluation Jobs in Amazon Bedrock allow systematic comparison of different foundation models through structured evaluation workflows, where users can incorporate human feedback to assess model performance.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      294,
      293,
      205,
      174,
      177
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 194,
    "question": "An e-commerce company with thousands of products needs to create unique, engaging product descriptions at scale. Which generative AI approach would most efficiently produce high-quality descriptions with minimal manual effort?",
    "choice_a": "Using Bedrock third-party foundation models with product attributes as prompts",
    "choice_b": "Creating a product data lake for automated template generation",
    "choice_c": "Adding human monitoring to review all AI-generated content",
    "choice_d": "Using Bedrock knowledge base to retrieve existing product information and using LLMs to create descriptions",
    "correct_answer": "D",
    "explanation": "Using a Bedrock knowledge base to retrieve existing product information and then leveraging Large Language Models to create unique descriptions enables the e-commerce company to efficiently generate high-quality, scalable product descriptions with minimal manual effort.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      131,
      130,
      59,
      78,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 195,
    "question": "A pharmaceutical company has millions of unlabeled medical documents and wants to adapt a foundation model to better understand domain-specific terminology. Which technique should they use?",
    "choice_a": "Fine-tuning with supervised learning",
    "choice_b": "Retrieval-Augmented Generation (RAG)",
    "choice_c": "Continued pre-training on domain data",
    "choice_d": "Advanced prompt engineering",
    "correct_answer": "C",
    "explanation": "Continued pre-training on domain-specific medical documents allows the pharmaceutical company to adapt a foundation model to understand specialized terminology by further training the model on their extensive collection of unlabeled medical research data.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      263,
      276,
      248,
      253,
      286
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 196,
    "question": "A legal tech company needs to implement an AI solution that can analyze entire case files (often 100+ pages) in a single operation without splitting the documents. Which foundation model characteristic is most critical for this task?",
    "choice_a": "Token vocabulary coverage",
    "choice_b": "Parameter count in billions",
    "choice_c": "Processing speed in tokens/second",
    "choice_d": "Maximum input token capacity",
    "correct_answer": "D",
    "explanation": "The maximum input token capacity is critical for analyzing entire case files in a single operation, enabling the legal tech company's AI solution to process lengthy documents without document splitting.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      175,
      174,
      248,
      194,
      223
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 197,
    "question": "When evaluating a new deep learning model for customer churn prediction, a data scientist notices the model achieves 98 percent accuracy on training data but only 72 percent on the validation dataset. What does this pattern indicate?",
    "choice_a": "Low training/validation performance gap",
    "choice_b": "High training/validation performance gap",
    "choice_c": "Appropriate generalization ability",
    "choice_d": "Insufficient training iterations",
    "correct_answer": "B",
    "explanation": "A high training/validation performance gap indicates that the deep learning model is overfitting, performing exceptionally well on training data but failing to generalize effectively to new, unseen validation data.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      10,
      307,
      9,
      292,
      11
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 198,
    "question": "A retail chain wants to predict product demand across its stores for the next quarter to optimize inventory purchasing. Which type of data would be most effective for training their forecasting model?",
    "choice_a": "Customer reviews and social media mentions",
    "choice_b": "Historical sales with timestamps and seasonality",
    "choice_c": "Products manually categorized by expected demand",
    "choice_d": "Browsing patterns without purchase outcomes",
    "correct_answer": "B",
    "explanation": "Historical sales data with timestamps and seasonality provides the most effective input for training a demand forecasting model, enabling the retail chain to predict product demand by capturing past sales trends and seasonal patterns.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      90,
      42,
      100,
      5,
      307
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 199,
    "question": "A company needs to evaluate potential bias in their customer service LLM with minimal administrative overhead. Which data source provides the most systematic assessment approach?",
    "choice_a": "Customer feedback and comments",
    "choice_b": "Human reviewer correction logs",
    "choice_c": "Company inclusivity guidelines",
    "choice_d": "Pre-configured bias testing datasets",
    "correct_answer": "D",
    "explanation": "Pre-configured bias testing datasets provide a systematic and standardized approach for evaluating potential biases in a customer service LLM, offering predefined prompts designed to reveal hidden model biases with minimal administrative overhead.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      205,
      293,
      175,
      225,
      204
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 200,
    "question": "A data science team needs to generate predictions on 200 GB of historical customer transaction data for a quarterly business review. The results aren’t needed immediately and can be processed overnight. Which SageMaker inference option is most appropriate?",
    "choice_a": "Real-time endpoints for immediate responses",
    "choice_b": "Auto-scaling endpoints with no instance management",
    "choice_c": "Batch jobs for processing entire datasets",
    "choice_d": "Queue-based processing with asynchronous endpoints",
    "correct_answer": "C",
    "explanation": "Batch transform (jobs) is most appropriate for processing 200 GB of historical customer transaction data overnight, efficiently handling large datasets for the quarterly business review with minimal computational overhead.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      326
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 201,
    "question": "A customer service team wants to use few-shot learning to improve their chatbot’s ability to identify specific customer intents from messages. What paired data elements must they include in their prompts?",
    "choice_a": "Example instructions and reference articles",
    "choice_b": "Example customer messages and their corresponding intents",
    "choice_c": "User demographic profiles and preferences",
    "choice_d": "Past conversations without intent classifications",
    "correct_answer": "B",
    "explanation": "Example customer messages paired with their corresponding intents are crucial for implementing few-shot learning, enabling the chatbot to quickly recognize and classify specific customer intent from new messages.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      199,
      200,
      248,
      194,
      195
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 202,
    "question": "A company wants to enhance their product search to understand customer intent rather than just matching keywords. Which Amazon OpenSearch feature enables this semantic understanding?",
    "choice_a": "Inverted index for text matching",
    "choice_b": "Vector embeddings with k-NN search",
    "choice_c": "Distributed storage architecture",
    "choice_d": "Authentication management system",
    "correct_answer": "B",
    "explanation": "Vector embeddings with k-Nearest Neighbors (k-NN) search enables semantic understanding in product search by converting product descriptions and search queries into vector representations, allowing for more nuanced, intent-based matching beyond simple keyword comparisons.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      62,
      67,
      66,
      131,
      130
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 203,
    "question": "A financial services company uses an LLM to process customer inquiries, but needs to prevent malicious users from injecting prompts that could bypass security controls. Which defense approach is most effective?",
    "choice_a": "Hash all user inputs before processing",
    "choice_b": "Limit model to pre-approved training sources",
    "choice_c": "Implement input filtering and instruction guardrails",
    "choice_d": "Block all external integrations",
    "correct_answer": "C",
    "explanation": "Implementing input filtering and instruction guardrails provides the most effective defense against prompt injection attacks, enabling the financial services company to detect and prevent malicious attempts to bypass security controls in their LLM-based customer inquiry system.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      380,
      379,
      375,
      410
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 204,
    "question": "When comparing different LLMs for processing long financial documents, what is the technical term for the maximum number of tokens a model can process in a single prompt?",
    "choice_a": "Top-K",
    "choice_b": "Batch size",
    "choice_c": "Context length",
    "choice_d": "Max temperature",
    "correct_answer": "C",
    "explanation": "Context length refers to the maximum number of tokens an LLM can process in a single prompt, determining the model's ability to handle long financial documents without splitting them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      66,
      67,
      78,
      333
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 205,
    "question": "A news organization using an LLM to generate article drafts notices that the AI occasionally creates convincing but fabricated quotes and statistics. What is this phenomenon called?",
    "choice_a": "Pattern overgeneralization",
    "choice_b": "Contextual misalignment",
    "choice_c": "Hallucination",
    "choice_d": "Factual dilution",
    "correct_answer": "C",
    "explanation": "A hallucination describes the phenomenon where an LLM generates plausible-sounding but entirely fabricated information, such as convincing but false quotes and statistics, presenting them with apparent confidence.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      82
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 206,
    "question": "What is the benefit of using Amazon Bedrock with RAG for a legal document assistant?",
    "choice_a": "Fast model fine-tuning",
    "choice_b": "Ability to index external documents",
    "choice_c": "Lower token cost",
    "choice_d": "Enhanced latency",
    "correct_answer": "B",
    "explanation": "Using Amazon Bedrock with Retrieval-Augmented Generation (RAG) enables the legal document assistant to index and dynamically retrieve external documents, providing contextually rich and up-to-date information during query processing.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      131,
      130,
      62,
      78,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 207,
    "question": "A company needs to validate model outputs for offensive content. What should they use?",
    "choice_a": "Guardrails for Amazon Bedrock",
    "choice_b": "Amazon Macie",
    "choice_c": "AWS CloudTrail",
    "choice_d": "AWS Glue",
    "correct_answer": "A",
    "explanation": "Guardrails for Amazon Bedrock provides content filtering and safety controls that help companies validate and prevent offensive or inappropriate model outputs during AI-generated content creation.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      380,
      410,
      379,
      378,
      381
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 208,
    "question": "A legal tech company’s document summarization model produces accurate but excessively verbose summaries. Which parameter should they adjust to create more concise outputs while maintaining key information?",
    "choice_a": "Token candidate pool size",
    "choice_b": "Output randomness level",
    "choice_c": "Maximum generation length",
    "choice_d": "Input capacity limit",
    "correct_answer": "C",
    "explanation": "Adjusting the maximum generation length allows the legal tech company to control the verbosity of their document summarization model, creating more concise outputs while preserving essential information.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      185,
      196,
      187,
      203,
      197
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 209,
    "question": "What learning strategy can adapt a pre-trained model to a new but similar task?",
    "choice_a": "Supervised learning",
    "choice_b": "Reinforcement learning",
    "choice_c": "Transfer learning",
    "choice_d": "Unsupervised learning",
    "correct_answer": "C",
    "explanation": "Transfer learning enables adapting a pre-trained model to a new but similar task by leveraging learned features from the original training, reducing the need for extensive retraining and improving performance on the target task.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      248,
      264,
      276,
      274,
      263
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 210,
    "question": "What approach can reduce inference cost for a frequently called foundation model?",
    "choice_a": "Using on-demand access",
    "choice_b": "Increasing batch size",
    "choice_c": "Prompt caching",
    "choice_d": "Reducing the size of the context window",
    "correct_answer": "C",
    "explanation": "Prompt caching helps reduce inference costs for frequently called foundation models by storing and reusing previous query responses, minimizing redundant computational processing and associated expenses.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      203,
      194,
      176,
      196,
      248
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 211,
    "question": "A security services company’s AI chatbot has been targeted by users attempting to extract sensitive information through carefully crafted prompts. Which AWS service should their security team implement to detect and block potential prompt injection attacks?",
    "choice_a": "Knowledge retrieval enhancement system",
    "choice_b": "Amazon Bedrock Guardrails",
    "choice_c": "ML bias detection toolkit",
    "choice_d": "Computer vision analysis service",
    "correct_answer": "B",
    "explanation": "Amazon Bedrock Guardrails provides content filtering and safety controls that help detect and block potential prompt injection attacks, preventing users from extracting sensitive information through manipulative prompts.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      378,
      380,
      379,
      381,
      375
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 212,
    "question": "A data scientist needs real-time responses with low latency from a generative model. What should they do?",
    "choice_a": "Use provisioned throughput",
    "choice_b": "Use SageMaker batch transform",
    "choice_c": "Use asynchronous inference",
    "choice_d": "Use Amazon Textract",
    "correct_answer": "A",
    "explanation": "Using provisioned throughput enables the data scientist to achieve real-time, low-latency responses from a generative model by dedicating specific computational resources for consistent and predictable performance.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      133,
      130,
      326,
      129,
      333
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 213,
    "question": "A retail marketing team needs AI-generated product descriptions to maintain consistent brand voice across multiple campaigns. Which technique will most effectively ensure tone consistency?",
    "choice_a": "Increasing output randomness to maximum level",
    "choice_b": "Creating standardized prompt examples with the desired tone",
    "choice_c": "Implementing vector similarity search",
    "choice_d": "Limiting word choice diversity during generation",
    "correct_answer": "B",
    "explanation": "Creating standardized prompt examples with the desired tone enables the retail marketing team to guide the AI in consistently generating product descriptions that reflect the brand's specific voice and communication style.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      199,
      200,
      198,
      195,
      194
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 214,
    "question": "Which approach ensures AI-generated summaries are understandable by different age groups?",
    "choice_a": "Using chain-of-thought reasoning",
    "choice_b": "Putting age descriptors in the prompt context",
    "choice_c": "Increasing the temperature",
    "choice_d": "Using a large batch size",
    "correct_answer": "B",
    "explanation": "Putting age descriptors in the prompt context instructs the AI to generate summaries tailored to specific age groups' comprehension levels, ensuring understandable and appropriately complex content.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      195,
      198,
      199,
      201,
      194
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 215,
    "question": "A company needs to ensure their AI models and predictions treats all demographic groups equitably. How can they systematically evaluate model fairness across different populations?",
    "choice_a": "By using BLEU score",
    "choice_b": "By running unit tests",
    "choice_c": "By using SageMaker Clarify",
    "choice_d": "By using Guardrails for Amazon Bedrock",
    "correct_answer": "C",
    "explanation": "SageMaker Clarify provides tools to systematically evaluate model fairness by analyzing bias and disparities across different demographic groups, helping companies ensure equitable AI predictions and model performance.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      357,
      358,
      339,
      347,
      346
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 216,
    "question": "A construction company uses drones to monitor worksite safety and needs to automatically identify equipment, workers, and safety hazards in aerial images. Which machine learning approach is most appropriate?",
    "choice_a": "Unsupervised grouping of similar image regions",
    "choice_b": "Vision theme extraction algorithm",
    "choice_c": "Computer vision with bounding box localization",
    "choice_d": "Image entity identification system",
    "correct_answer": "C",
    "explanation": "Computer vision with bounding box localization enables the construction company to automatically identify and precisely locate equipment, workers, and safety hazards in aerial drone images by drawing precise rectangular boundaries around detected objects.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      104,
      44,
      103,
      12,
      9
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 217,
    "question": "A technical support team needs their AI assistant to accurately answer customer questions using information from constantly updated product manuals in PDF format. Which approach allows the chatbot to access this information without retraining?",
    "choice_a": "RAG",
    "choice_b": "Fine-tuning",
    "choice_c": "Prompt chaining",
    "choice_d": "Transfer learning",
    "correct_answer": "A",
    "explanation": "Retrieval-Augmented Generation (RAG) enables the AI assistant to dynamically access and incorporate information from constantly updated product manuals, providing accurate responses without requiring model retraining.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      131,
      130,
      133,
      129,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 218,
    "question": "What learning type is used to classify customers into tiers using only transaction data?",
    "choice_a": "Reinforcement learning",
    "choice_b": "Supervised learning",
    "choice_c": "Transfer learning",
    "choice_d": "Unsupervised learning",
    "correct_answer": "D",
    "explanation": "Unsupervised learning enables customer classification into tiers by automatically discovering patterns and grouping customers based on transaction data without predefined labels or manual intervention.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      102,
      6,
      8,
      41
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 219,
    "question": "A team wants to ensure their LLM does not reveal PII. What should they use?",
    "choice_a": "Amazon GuardDuty",
    "choice_b": "Guardrails for Amazon Bedrock",
    "choice_c": "AWS Macie",
    "choice_d": "SageMaker Ground Truth",
    "correct_answer": "B",
    "explanation": "Guardrails for Amazon Bedrock provides content filtering and safety controls that help prevent the disclosure of Personally Identifiable Information (PII) in Large Language Model outputs.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      380,
      410,
      403,
      374,
      402
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 220,
    "question": "A generative model must write short poems with the same structure each time. What technique is best?",
    "choice_a": "Zero-shot prompting",
    "choice_b": "Temperature = 1",
    "choice_c": "Prompt engineering with templates",
    "choice_d": "Multi-modal input",
    "correct_answer": "C",
    "explanation": "Prompt engineering with templates consistently generates poems with the same structure by using detailed guidelines and specific format instructions within the initial prompt context.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      197,
      195,
      194,
      199,
      237
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 221,
    "question": "A global e-commerce company needs to evaluate their machine translation system that converts product descriptions into 12 languages. Which specialized metric should they use to assess translation quality?",
    "choice_a": "Bilingual Evaluation Understudy (BLEU) score",
    "choice_b": "Root Mean Squared Error calculation (RMSE)",
    "choice_c": "Classification correctness percentage (Accuracy)",
    "choice_d": "Mean Absolute Error measurement (MAE)",
    "correct_answer": "A",
    "explanation": "The Bilingual Evaluation Understudy (BLEU) score provides a specialized metric for assessing machine translation quality. It does so by comparing generated translations against reference human translations across multiple languages.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      293,
      262,
      175,
      225,
      205
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 222,
    "question": "A legal department needs to convert thousands of scanned contract PDFs into searchable, editable text while preserving the document structure and tables. Which AWS service is specifically designed for this document-processing task?",
    "choice_a": "Amazon Rekognition",
    "choice_b": "Amazon Textract",
    "choice_c": "Amazon Polly",
    "choice_d": "Amazon Translate",
    "correct_answer": "B",
    "explanation": "Amazon Textract is specifically designed to extract text and preserve document structure from scanned PDFs, enabling the legal department to convert contract documents into searchable and editable formats while maintaining the original layout and table information.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      62,
      131,
      134,
      135,
      130
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 223,
    "question": "A company needs to generate realistic but synthetic customer transaction data for testing fraud detection algorithms without using actual customer information. Which machine learning model is best suited for this synthetic data-generation task?",
    "choice_a": "Decision tree",
    "choice_b": "GAN (Generative Adversarial Network)",
    "choice_c": "Logistic regression",
    "choice_d": "XGBoost",
    "correct_answer": "B",
    "explanation": "Generative Adversarial Networks (GANs) are best suited for generating realistic synthetic customer transaction data. They train two neural networks to create and validate artificial data that closely mimics the statistical properties of original datasets.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      69,
      106,
      59,
      82,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 224,
    "question": "A customer service AI chatbot is providing factually correct but inconsistent responses to similar questions, sometimes being formal and other times casual in tone. Which model parameter should be adjusted to increase response consistency?",
    "choice_a": "Top-P",
    "choice_b": "Temperature",
    "choice_c": "Max context window",
    "choice_d": "Batch size",
    "correct_answer": "B",
    "explanation": "Lowering the temperature parameter helps increase response consistency by reducing the randomness in the AI chatbot's outputs, ensuring a more predictable and uniform tone across similar customer service interactions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      185,
      186,
      187,
      199,
      198
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 225,
    "question": "A legal team wants to summarize contracts and extract clauses using generative AI. What solution meets this need?",
    "choice_a": "Build a named entity recognition pipeline",
    "choice_b": "Use a summarization model with document parsing",
    "choice_c": "Use Amazon Rekognition to classify document types",
    "choice_d": "Apply clustering to legal terms",
    "correct_answer": "B",
    "explanation": "A summarization model with document parsing enables the legal team to automatically extract and condense contract clauses, leveraging generative AI to process and summarize complex legal documents efficiently.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      107,
      131,
      78,
      130,
      129
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 226,
    "question": "A creative agency needs to quickly produce diverse visual concepts for client presentations without hiring additional graphic designers. Which application represents a core strength of generative AI technology?",
    "choice_a": "Using real-time fraud detection",
    "choice_b": "Creating marketing images from text descriptions",
    "choice_c": "Training data compression",
    "choice_d": "Predicting time-series trends",
    "correct_answer": "B",
    "explanation": "Creating marketing images from text descriptions is a core strength of generative AI technology, because it allows the creative agency to rapidly produce diverse visual concepts by converting textual descriptions into realistic images.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      69,
      68,
      106,
      59,
      78
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 227,
    "question": "A medical research team needs to classify gene expressions related to cancer risk while being able to explain the specific factors influencing each prediction to regulatory authorities. Which machine learning approach offers the best balance of accuracy and interpretability?",
    "choice_a": "Decision trees",
    "choice_b": "Neural networks",
    "choice_c": "Random forest",
    "choice_d": "GANs",
    "correct_answer": "A",
    "explanation": "Decision trees offer the best balance of accuracy and interpretability for gene expression classification. They provide a clear, transparent model that can easily explain the specific factors influencing each cancer risk prediction.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      339,
      358,
      357
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 228,
    "question": "A data scientist is explaining how language models understand semantic relationships between words in customer reviews. What term describes the dense numerical vectors that capture word meaning and allow models to process similar concepts?",
    "choice_a": "Tokens",
    "choice_b": "Contexts",
    "choice_c": "Embeddings",
    "choice_d": "Layers",
    "correct_answer": "C",
    "explanation": "Embeddings are dense numerical vectors that capture semantic relationships between words, allowing language models to understand and process similar concepts by representing words in a multi-dimensional vector space.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      62,
      66,
      67,
      68,
      106
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 229,
    "question": "A facial recognition system used for building access shows significantly higher error rates for specific ethnic groups. Which category of bias does this represent?",
    "choice_a": "Measurement bias",
    "choice_b": "Observer bias",
    "choice_c": "Sampling bias",
    "choice_d": "Confirmation bias",
    "correct_answer": "C",
    "explanation": "Sampling bias occurs when the training data does not proportionally or representatively include diverse ethnic groups, leading to skewed performance and higher error rates for underrepresented populations in the facial recognition system.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      339,
      357,
      358,
      370
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 230,
    "question": "A chatbot needs to be deployed with compliance and privacy controls. Which capabilities help? (Choose two.)",
    "choice_a": "Data protection",
    "choice_b": "Loosely coupled microservices",
    "choice_c": "Cost optimization",
    "choice_d": "Threat detection",
    "choice_e": "Auto-scaling endpoints",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Data protection and threat detection both help ensure compliance and privacy controls for a chatbot by safeguarding sensitive information and preventing unauthorized access or potential security breaches.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      410,
      380,
      412,
      403,
      374
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 231,
    "question": "A healthcare company uses Amazon Bedrock to process patient data from multiple hospitals, but they need to ensure that each hospital can only access their own patient information. How should they implement this data isolation?",
    "choice_a": "Deploy separate Bedrock environments for each customer",
    "choice_b": "Configure IAM policies restricting S3 access by customer ID",
    "choice_c": "Enable comprehensive CloudTrail monitoring",
    "choice_d": "Apply customer-specific encryption keys",
    "correct_answer": "B",
    "explanation": "Configuring IAM policies to restrict S3 access by customer ID enables the healthcare company to ensure that each hospital can only access their own patient information. This creates granular data isolation in Amazon Bedrock.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      403,
      410,
      374,
      413,
      381
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 232,
    "question": "A software company has hundreds of technical PDF manuals totaling over 20,000 pages and wants their customer support chatbot to accurately answer specific product questions. What’s the most cost-effective solution?",
    "choice_a": "Add all manuals as prompt context",
    "choice_b": "Use a Bedrock knowledge base to index the PDFs",
    "choice_c": "Train a model with labeled examples",
    "choice_d": "Run on-demand fine-tuning",
    "correct_answer": "B",
    "explanation": "Using a Bedrock knowledge base to index the PDFs provides a cost-effective way to enable the customer support chatbot to dynamically retrieve and reference specific information from hundreds of technical manuals.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      131,
      133,
      130,
      129,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 233,
    "question": "A global e-commerce company is using Amazon Bedrock Model Evaluation to compare the quality of multiple foundation models for product description translation. They want to configure the LLM as a Judge feature to automatically assess translation quality. Which metric should they select for the evaluation job?",
    "choice_a": "F1 Score (balance of precision and recall)",
    "choice_b": "ROUGE (overlap of generated and reference summaries)",
    "choice_c": "BLEU (comparison against human reference translations)",
    "choice_d": "Precision (accuracy of positive identifications)",
    "correct_answer": "C",
    "explanation": "The BLEU (Bilingual Evaluation Understudy) score provides an effective metric for automatically assessing translation quality by comparing generated product description translations against human reference translations.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      293
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 234,
    "question": "A cybersecurity team needs to identify suspicious IP addresses accessing their cloud infrastructure that deviate from normal access patterns without predefined rules. Which machine learning approach is most appropriate?",
    "choice_a": "Clustering model",
    "choice_b": "Sequence prediction model",
    "choice_c": "Named entity recognition",
    "choice_d": "Anomaly detection model",
    "correct_answer": "D",
    "explanation": "An anomaly detection model enables the cybersecurity team to identify suspicious IP addresses by learning normal access patterns and flagging deviations that potentially indicate security threats or unauthorized access.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      6,
      41,
      8,
      42,
      102
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 235,
    "question": "A healthcare application uses AI to analyze patient records and generate treatment summaries. The team needs to ensure that the model never outputs protected health information (PHI) even if it appears in the input. What solution should they implement?",
    "choice_a": "Guardrails for Amazon Bedrock",
    "choice_b": "AWS Key Management Service",
    "choice_c": "Macie with SageMaker",
    "choice_d": "Fine-tune a smaller model",
    "correct_answer": "A",
    "explanation": "Guardrails for Amazon Bedrock provides content filtering and safety controls that prevent the output of protected health information (PHI), ensuring the AI-generated treatment summaries comply with privacy regulations.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      380,
      410,
      413,
      403,
      379
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 236,
    "question": "A data science team is beginning a new project to predict customer churn using historical transaction data. Before building models, they need to understand data distributions, detect outliers, and identify correlations between variables. Which stage of the ML workflow focuses on these activities?",
    "choice_a": "Feature engineering",
    "choice_b": "Exploratory Data Analysis (EDA)",
    "choice_c": "Hyperparameter tuning",
    "choice_d": "Model training",
    "correct_answer": "B",
    "explanation": "Exploratory Data Analysis (EDA) enables the data science team to understand data distributions, detect outliers, and identify correlations between variables before model development, providing critical insights into the dataset's characteristics.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      163,
      306,
      42,
      307,
      162
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 237,
    "question": "An educational publisher uses generative AI to create interactive children’s stories. They need to ensure the content remains age-appropriate by preventing the model from generating violent, inappropriate, or frightening material. Which AWS feature is specifically designed to enforce these content safety policies?",
    "choice_a": "Guardrails for Amazon Bedrock",
    "choice_b": "SageMaker Model Monitor",
    "choice_c": "Amazon Rekognition",
    "choice_d": "SageMaker Clarify",
    "correct_answer": "A",
    "explanation": "Guardrails for Amazon Bedrock provides content filtering and safety controls that prevent the generation of violent, inappropriate, or frightening material, ensuring age-appropriate content for children's stories.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      380,
      379,
      378,
      410,
      374
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 238,
    "question": "A company needs an AI system that can answer customer questions about product photos. Which model type can handle the images and text questions together?",
    "choice_a": "Text generation model",
    "choice_b": "Multi-modal generation model",
    "choice_c": "Image captioning model",
    "choice_d": "Text embedding model",
    "correct_answer": "B",
    "explanation": "A multi-modal generation model enables the company to process both product images and text questions simultaneously, providing comprehensive AI-powered customer support across visual and textual inputs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      68,
      69,
      78,
      59,
      107
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 239,
    "question": "What is a benefit of Amazon Bedrock agents in customer support automation?",
    "choice_a": "Personalized email generation",
    "choice_b": "Ability to orchestrate multi-step tasks",
    "choice_c": "Custom model training",
    "choice_d": "Semantic search across logs",
    "correct_answer": "B",
    "explanation": "Bedrock agents enable customer support automation by orchestrating multi-step tasks, allowing complex workflows to be completed efficiently through intelligent, context-aware interactions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      131,
      133,
      130,
      129,
      78
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 240,
    "question": "A wildlife conservation app needs to identify and classify different animal species in photos submitted by citizen scientists. Which AI approach is most appropriate for this image analysis task?",
    "choice_a": "Named entity recognition",
    "choice_b": "Topic modeling",
    "choice_c": "Object detection",
    "choice_d": "Reinforcement learning",
    "correct_answer": "C",
    "explanation": "Object detection enables the wildlife conservation app to identify and classify different animal species in citizen scientist photos by precisely locating and labeling specific animal types within images.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      104,
      44,
      101,
      8,
      41
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 241,
    "question": "Under the Generative AI Security Scoping Matrix, which of the following gives customers the most security responsibility?",
    "choice_a": "Using pre-trained FMs",
    "choice_b": "Fine-tuning a third-party FM",
    "choice_c": "Building and training an FM from scratch",
    "choice_d": "Using managed chat APIs",
    "correct_answer": "C",
    "explanation": "Building and training a Foundation Model from scratch provides customers with the most security responsibility in the Generative AI Security Scoping Matrix, requiring comprehensive management of the entire model development process.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      382,
      381,
      374,
      399,
      410
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 242,
    "question": "A large enterprise wants to implement an AI assistant that can access company documentation, answer employee questions about internal policies, and help with technical troubleshooting based on their specific systems. Which AWS service should they use?",
    "choice_a": "Amazon Lex for custom chatbot development",
    "choice_b": "Amazon Q for enterprise knowledge assistance",
    "choice_c": "Amazon Kendra for document search capabilities",
    "choice_d": "Amazon SageMaker for custom model deployment",
    "correct_answer": "B",
    "explanation": "Amazon Q provides enterprise knowledge assistance by enabling the AI assistant to access, understand, and dynamically respond to employee questions about internal policies and technical systems using company documentation.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      134,
      135,
      131,
      107,
      129
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 243,
    "question": "A model performs well on training data but poorly on live inputs. What’s the likely fix?",
    "choice_a": "Increase model size",
    "choice_b": "Add inference delay",
    "choice_c": "Use more diverse production-like data",
    "choice_d": "Reduce training epochs",
    "correct_answer": "C",
    "explanation": "Using more diverse production-like data helps address model performance issues by ensuring the training dataset more closely represents real-world scenarios, improving generalization and reducing overfitting.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      306,
      10,
      307,
      5,
      12
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 244,
    "question": "Which prompt engineering technique helps classify sentiment from text more accurately?",
    "choice_a": "Explain the task in the prompt",
    "choice_b": "Provide sentiment labels as examples",
    "choice_c": "Use chain-of-thought reasoning",
    "choice_d": "Leave the prompt open-ended",
    "correct_answer": "B",
    "explanation": "Providing sentiment labels as examples in the prompt helps improve sentiment classification accuracy by demonstrating the desired classification approach and giving the model clear context for interpretation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      199,
      200,
      195,
      202,
      194
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 245,
    "question": "After deploying a customer churn prediction model to production, a data scientist notices the model’s accuracy has declined over three months. Which phase of the machine learning lifecycle should the team focus on next?",
    "choice_a": "Feature engineering",
    "choice_b": "Model monitoring",
    "choice_c": "Hyperparameter tuning",
    "choice_d": "Model deployment",
    "correct_answer": "B",
    "explanation": "Model monitoring enables the data science team to track the performance of the customer churn prediction model over time, identifying and addressing drift or degradation in accuracy after deployment.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      300,
      307,
      164,
      313,
      292
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 246,
    "question": "How can a developer get shorter, language-specific responses from a pre-trained chatbot?",
    "choice_a": "Add format and language constraints in the prompt",
    "choice_b": "Fine-tune the model",
    "choice_c": "Reduce the temperature",
    "choice_d": "Use SageMaker Ground Truth",
    "correct_answer": "A",
    "explanation": "Adding format and language constraints in the prompt allows developers to instruct the pre-trained chatbot to generate shorter, language-specific responses by explicitly defining desired output characteristics.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      197,
      196,
      195,
      185,
      175
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 247,
    "question": "What’s needed to fine-tune a Bedrock model for better AI search performance?",
    "choice_a": "Provide labeled prompt-response training data",
    "choice_b": "Use Top-K sampling",
    "choice_c": "Use BLEU scoring",
    "choice_d": "Add a summarization pipeline",
    "correct_answer": "A",
    "explanation": "Providing labeled prompt-response training data enables developers to fine-tune a Bedrock model for improved AI search performance by teaching the model specific query-response patterns and context.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      276,
      262,
      248,
      286,
      176
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 248,
    "question": "How can a team evaluate foundation models for writing that matches company style?",
    "choice_a": "Use predefined Bedrock examples",
    "choice_b": "Create human evaluation with custom prompts",
    "choice_c": "Use CloudWatch Invocation Latency metrics",
    "choice_d": "Choose the model with the highest token throughput",
    "correct_answer": "B",
    "explanation": "Creating human evaluation with custom prompts allows the team to systematically assess foundation models by directly comparing their outputs against the company's specific writing style and communication guidelines.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      293,
      294,
      174,
      205,
      195
    ],
    "source": "328192_PracticeTest2"
  },
  {
    "id": 249,
    "question": "A marketing department needs to create interactive dashboards showing campaign performance metrics across regions with drill-down capabilities and automatic data refreshes. Which AWS service should they use?",
    "choice_a": "Amazon QuickSight",
    "choice_b": "Amazon Athena",
    "choice_c": "Amazon CloudWatch",
    "choice_d": "Amazon Redshift",
    "correct_answer": "A",
    "explanation": "Amazon QuickSight enables the marketing department to create interactive dashboards with campaign performance metrics, providing drill-down capabilities and automatic data refreshes across different regions.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      150,
      151,
      148,
      149,
      162
    ],
    "source": "328192_PracticeTest2"
  }
];
